export default {
    bsc_name: {
        title: "住宅タイプの名称",
        text: "<ul><li>戸建住宅の名称や共同住宅の住戸の名称を文字列（例えば「○×ビル新築工事」）で入力して下さい。</li>" +
            "<li>共同住宅で評価条件が共通する複数の住戸を一括して評価する場合などは、住戸タイプの名称を記入して下さい。</li></ul>",
    },
    bsc_tatekata: {
        title: "住宅の建て方",
        text: "<ul><li>共同住宅、長屋その他の一戸建て住宅以外の住宅及び複合建築物を評価する場合は「共同住宅」を選択して下さい。</li></ul>"
    },
    bsc_kyoshitsu_kousei: {
        title: "居室の構成",
        text: "<ul><li>暖冷房や照明の一次エネルギー消費量は、「主たる居室」、「その他の居室」、「非居室」の居室別に計算を行います。" +
            "ここではそれらの居室の有無を確認するため、住戸全体の居室の構成を確認します。各居室の定義は以下のとおりです。" +
            "<ul><li>「主たる居室」とは、当該住戸又は当該住戸の部分における熱的境界の内側に存する居室のうち、基本生活行為において、" +
            "就寝を除き日常生活上在室時間が長い居室のことであり、居間（リビング）、食堂（ダイニング）及び台所（キッチン）をいいます。</li>" +
            "<li>「その他の居室」とは、当該住戸又は当該住戸の部分における熱的境界の内側に存する居室のうち、主たる居室以外の居室をいいます。</li>" +
            "<li>「非居室」とは、当該住戸又は当該住戸の部分における熱的境界の内側に存する居室以外の空間をいいます。</li></ul>" +
            "<figure><img src='/img/app/basic001.jpg'><figcaption>図．室の分類の例</figcaption></figure></li>" +
            "<li>住戸が「主たる居室」、「その他の居室」、「非居室」で構成される場合は、「主たる居室とその他の居室、非居室で構成される」を選択してください。" +
            "居室の構成がこれに該当しない場合、例えば「その他の居室」は無く、「主たる居室」と「非居室」で構成される場合などは、「それ以外の構成」を選択してください。</li></ul>"
    },
    bsc_nobeyuka_menseki: {
        title: "床面積",
        text: "<ul><li>一次エネルギー消費量は床面積に依存して計算するため、ここに入力する床面積は、基準一次エネルギー消費量および" +
            "設計一次エネルギー消費量を算出する際の必須項目となります。居室ごとに消費量を計算する用途もあることから、「主たる居室」、" +
            "「その他の居室」、床面積の「合計」（非居室は入力値から自動計算されます）を入力します。</li>" +
            "<li>居室及び非居室の床面積の計算は、当該住戸又は当該住戸の部分における熱的境界の内側に存する床面積のうち、" +
            "間仕切りや扉等で区切られた居室及び非居室ごとに計算します。ただし、下表の場合はこの限りではありません。</li>" +
            "<table><caption>表1 床面積算出の特例</caption><tbody>" +
            "<tr><th>風除室、サンルーム</th><td>非密閉空気層とする場合の風除室及びサンルームの床面積は、床面積に算入しない。" +
            "ただし、風除室等を熱的境界に囲まれた空間とみなす場合は床面積に算入する。</td></tr>" +
            "<tr><th>出窓</th><td>外壁面からの突出が500㎜未満、かつ、下端の床面からの高さが300㎜以上である腰出窓の面積は、床面積に算入しない。</td></tr>" +
            "<tr><th>小屋裏収納、床下収納</th><td>熱的境界の内側に存する小屋裏収納、床下収納のうち、建築基準法で定める延べ面積に算入されない" +
            "小屋裏収納及び床下収納の面積は、床面積に算入しない。</td></tr>" +
            "<tr><th>物置等</th><td>居室に面する部位が断熱構造となっている物置、車庫その他これらに類する空間（以下、「物置等」という。）の床面積は、" +
            "床面積に算入しない。</td></tr>" +
            "</tbody></table>" +
            "<li>床面積の算出は、以下を参考に算出して下さい。<ol>" +
            "<li>「主たる居室」の床面積<br>「主たる居室」の面積は、リビング（居間）、ダイニング（食堂）及びキッチン（台所）の床面積の合計とする。" +
            "また、これらの室は独立していても「主たる居室」として床面積を算出する。複数のリビング（居間）、ダイニング（食堂）及びキッチン（台所）がある場合には、" +
            "全ての床面積の合計を「主たる居室」の面積とする。また、コンロその他調理する設備又は機器を設けた室は「キッチン（台所）」として扱い、「主たる居室」として床面積を算出する。</li>" +
            "<li>「その他の居室」の床面積<br>「その他の居室」の面積は、「主たる居室」以外の寝室、洋室及び和室等の居室の床面積の合計とする。</li>" +
            "<li>「非居室」の床面積<br>「非居室」の面積は、「主たる居室」及び「その他の居室」以外の浴室、トイレ、洗面所、廊下、玄関、" +
            "間仕切り及び扉等で区切られた押し入れ並びにクローゼット等の収納等の床面積の合計とする。ただし、収納が居室に付随している場合は、" +
            "それが属する居室の一部としてみなし、当該居室に分類して床面積の算定を行うことも可能とする。</li>" +
            "<li>床面積の合計<br>床面積の合計は、「主たる居室」、「その他の居室」及び「非居室」の床面積の合計とする。</li>" +
            "<li>吹抜け等の扱い<br>住戸内に吹抜け等を有する場合は、当該吹抜け部分に仮想床があるものとみなして、床面積を計算する。" +
            "ここで「吹抜け等」とは、吹抜け及び天井の高さが4.2m以上の居室及び非居室を指し、「吹抜け」とは、複数の階をまたいで床を設けず上下方向に連続した空間を指す。" +
            "仮想床の面積は、吹抜け等が存する「主たる居室」、「その他の居室」又は「非居室」の面積に加えることとする。" +
            "天井の高さが4.2m以上の場合、高さ2.1mの部分に仮想床があるものとみなして、当該居室又は非居室の床面積に仮想床の床面積を加えて計算する。" +
            "天井の高さが6.3m以上の場合、高さ2.1m及び4.2mの部分に仮想床があるものとみなして、当該居室又は非居室の床面積に仮想床の床面積を加えて計算する。" +
            "以下同様に、天井高さが2.1m増えるごとに仮想床を設ける。</li>" +
            "<li>一体的空間の扱いについて<br>間仕切り壁や扉等がなく、水平方向及び垂直方向に空間的に連続する場合は、ひとつの室とみなして床面積を算出する。" +
            "また、吹抜け等に面して開放された空間についても、当該吹抜け等が存する「主たる居室」、「その他の居室」又は「非居室」と一体であると判断し、床面積を算定することとする。" +
            "なお、「主たる居室」と空間的に連続する「その他の居室」及び「非居室」は「主たる居室」に含めることとし、" +
            "「その他の居室」と空間的に連続する「非居室」は「その他の居室」に含めることとして床面積を算出する。</li>" +
            "</ol></li></ul>"
    },
    bsc_solarlv_specify: {
        title: "年間の日射地域区分の指定",
        text: "<ul><li>水平面全天日射量の年間積算値を指標として日本全国を日射の少ない地域から多い地域まで5地域に分類した地域区分のことです。" +
            "太陽光発電又は太陽熱利用設備を採用する場合は年間の日射地域区分を選択して下さい。</li>" +
            "<li>令和1年11月16日に新しい地域区分が施行されました。当該住戸の年間の日射地域区分は、" +
            "<a href='/img/help/02_env_chiki.xlsx' target='_blank'>こちら</a>を参照して下さい。" +
            "なお、経過措置として、令和3年3月31日までは、<a href='/img/help/02_env_chiki.pdf' target='_blank'>旧地域区分</a>の使用も可能です。</li></ul>"
    },
    env_chiki: {
        title: "地域の区分",
        text: "<ul><li>省エネルギー基準の地域の区分とは、全国を市町村単位別に主に外気条件を評価軸として8つの地域に分けた区分のことで、1～8の地域の区分として表しています。" +
            "それぞれの地域において気候条件の差が大きく、暖房、冷房、給湯などの一次エネルギー消費量の結果が大きく異なってしまうため、気候条件の差を小さくし、" +
            "適切に省エネルギー性能を評価することを目的として8区分に細分化しました。" +
            "当該住戸の地域の区分は、<a href='/img/help/02_env_chiki.pdf' target='_blank'>こちら</a>を参照して下さい。</li></ul>"
    },
    ip_houhou: {
        title: "評価方法の選択",
        text: "<ul><li>「当該住戸の外皮面積を用いて外皮性能を評価する」とは、当該住戸の屋根・天井、壁、窓、床などの外皮面積と各部位の断熱性能を用いて外皮性能（UA、ηAC、ηAH）を評価する方法です。" +
            "一次エネルギー消費量の評価において、外皮性能評価時に算出した当該住戸の「外皮面積の合計」を用います。" +
            "「当該住戸の外皮面積を用いず外皮性能を評価する（一戸建ての住宅で木造の単位住戸の評価に限る）」場合に比べて、外皮性能を適切に反映することができ、多くの場合に評価は高く算出されます。</li>" +
            "<li>一戸建ての住宅で木造の単位住戸の評価に限り、「当該住戸の外皮面積を用いず外皮性能を評価する」方法が選択できます。" +
            "当該住戸の屋根・天井、壁、床などの外皮面積を算出せず簡易評価式により外皮性能を評価する方法です。" +
            "一次エネルギー消費量の評価では当該住戸の「床面積の合計」から推計値した値を用いますので「外皮面積の合計」を入力する必要はありません。" +
            "既に別途エクセルや評価ツールなどを用いて事前に計算した外皮性能（UA、ηAC、ηAH）をお持ちの場合は、「当該住戸の外皮面積を用いず外皮性能を評価する（別途計算）」を選択して評価して下さい。" +
            "各部位の熱貫流率や窓の日射取得率を直接入力して評価する場合は、「当該住戸の外皮面積を用いず外皮性能を評価する（ここで計算）」を選択して評価して下さい。</li></ul>",
    },
    bsc_sougaihi_menseki: {
        title: "外皮面積の合計",
        text: "<ul><li>天井・屋根、壁、開口部、床等の外皮面積の合計のことです。</li>" +
            "<li>計算した結果は、小数点第3位を四捨五入した小数点以下2桁で入力して下さい。</li></ul>"
    },
    ip_u_value: {
        title: "外皮平均熱貫流率",
        text: "<ul><li>外皮平均熱貫流率とは、単位温度差あたりの外皮熱損失量のことで、室内外の温度差が1度のときの、" +
            "外皮（天井・屋根、壁、床等）の熱損失量の合計を外皮面積の合計で除した値になります（単位はW／K）。</li>" +
            "<li>なお、共同住宅の場合は、部位の熱損失量に界壁と界床の熱損失量も含みます。" +
            "界壁とは、共同住宅等において隣接する住戸や共用部に接する壁のことです（戸境壁ともいう）。" +
            "界床とは、共同住宅等において隣接する住戸及び共用部に接する床のことです（戸境床ともいう）。</li>" +
            "<li>計算した結果は、小数点第3位以下を切り上げて、小数点以下2桁で入力して下さい。</li></ul>"
    },
    ss_eta_value: {
        title: "冷房期平均日射熱取得率",
        text: "<ul><li>冷房期平均日射熱取得率とは、屋根、外壁、窓等の外皮の各部位から入射する日射量を外皮面積の合計で除した値で、下式によって求められます。</li>" +
            "<img src='/img/help/ss_eta_value.jpg' alt='' />" +
            "<li>計算した結果は、小数点第2位以下を切り上げて、小数点以下1桁で入力して下さい。</li></ul>",
    },
    sw_eta_value: {
        title: "暖房期平均日射熱取得率",
        text: "<ul><li>暖房期平均日射熱取得率とは、屋根、外壁、窓等の外皮の各部位から入射する日射量を外皮面積の合計で除した値で、下式によって求められます。</li>" +
            "<img src='/img/help/sw_eta_value.jpg' alt='' />" +
            "<li>計算した結果は、小数点第2位以下を切り下げて、小数点以下1桁で入力して下さい。</li></ul>",
    },
    nw_ldk_houhou: {
        title: "通風の利用（主たる居室）",
        text: "<ul><li>当該住戸の「主たる居室」について、冷房期に通風を利用する程度を換気回数の程度（下表）に応じて選択して下さい。" +
            "<table><tbody>" +
            "<tr><th>優先順位</th><th>選択肢</th></tr>" +
            "<tr><th>1</th><td>評価しない、または利用しない</td></tr>" +
            "<tr><th>2</th><td>利用する（換気回数5回/h相当以上）</td></tr>" +
            "<tr><th>3</th><td>利用する（換気回数20回/h相当以上）</td></tr>" +
            "</tbody></table>" +
            "通風の利用の程度（相当する換気回数）の確認方法については、" +
            "<a href='/img/help/05_nw_ldk_houhou_nw_nldk_houhou.pdf' target='_blank'>こちら</a>を参照して下さい。</li></ul>",
    },
    nw_nldk_houhou: {
        title: "通風の利用（その他の居室）",
        text: "<ul><li>当該住戸の「その他の居室」について、冷房期に通風を利用する程度を換気回数の程度（下表）に応じて選択して下さい。</li>" +
            "<li>「その他の居室」が複数ある場合で、通風の利用の程度が異なる場合は、それぞれの居室の通風の利用の程度を評価し、下表の優先順位の最も高い（値の小さい）評価を適用して下さい。" +
            "<table><tbody>" +
            "<tr><th>優先順位</th><th>選択肢</th></tr>" +
            "<tr><th>1</th><td>評価しない、または利用しない</td></tr>" +
            "<tr><th>2</th><td>利用する（換気回数5回/h相当以上）</td></tr>" +
            "<tr><th>3</th><td>利用する（換気回数20回/h相当以上）</td></tr>" +
            "</tbody></table>" +
            "通風の利用の程度（相当する換気回数）の確認方法については、" +
            "<a href='/img/help/05_nw_ldk_houhou_nw_nldk_houhou.pdf' target='_blank'>こちら</a>を参照して下さい。</li></ul>",
    },
    sh_nisshanetsuriyo: {
        title: "蓄熱の利用",
        text: "<ul><li>蓄熱の利用の程度は、地域区分における暖房期の日射地域区分に応じて下表のように定められており、「可」と表記のある区分のみ評価可能です。" +
            "「不可」に該当する区分の場合は、蓄熱の評価はできません。" +
            "当該住戸の暖房期日射地域区分は、<a href='/img/help/02_env_chiki_chikikubun.pdf' target='_blank'>こちら</a>を参照して下さい。</li>" +
            "<table><thead>" +
            "<tr><th rowspan='2'>地域区分</th><th colspan='5'>暖房期の日射地域区分</th></tr>" +
            "<tr><th>H1</th><th>H2</th><th>H3</th><th>H4</th><th>H5</th></tr>" +
            "</thead><tbody>" +
            "<tr><th>1</th><td>不可</td><td>不可</td><td>可</td><td>可</td><td>可</td></tr>" +
            "<tr><th>2</th><td>不可</td><td>不可</td><td>可</td><td>可</td><td>可</td></tr>" +
            "<tr><th>3</th><td>不可</td><td>不可</td><td>可</td><td>可</td><td>可</td></tr>" +
            "<tr><th>4</th><td>不可</td><td>不可</td><td>可</td><td>可</td><td>可</td></tr>" +
            "<tr><th>5</th><td>不可</td><td>不可</td><td>可</td><td>可</td><td>可</td></tr>" +
            "<tr><th>6</th><td>不可</td><td>不可</td><td>不可</td><td>可</td><td>可</td></tr>" +
            "<tr><th>7</th><td>不可</td><td>不可</td><td>不可</td><td>可</td><td>可</td></tr>" +
            "</tbody></table>" +
            "<li>上記表より「可」である地域において、蓄熱を「利用する」を選択できる要件は、蓄熱部位の熱容量が当該住戸の床面積当たり" +
            "170kJ/(m2K)以上の熱容量の増加が見込まれる材料を蓄熱部位に用いている場合に認められます。</li>" +
            "<li>蓄熱部位とは、蓄熱の利用に有効な熱容量を持つ部位をいい、天井、床（断熱区画内の床も含む）、壁（外気に接する壁及び間仕切壁）及び界壁・界床を対象とします。" +
            "蓄熱の利用に関する要件は、<a href='/img/help/06_sh_nisshanetsuriyo.pdf' target='_blank'>こちら</a>を参照して下さい。</li></ul>",
    },
    ip_ufv: {
        title: "床下空間を経由して外気を導入する換気方式の採用",
        text: "<ul><li>床下換気システムとは、床下空間を経由して外気を室内へ導入する換気方式を採用したシステムです。" +
            "外気温度に比べて室温変動が緩やかな床下空間に外気を導入することにより、換気負荷を低減させ、暖冷房のエネルギー消費量を削減する効果が見込めます。</li>" +
            "<li>床下空間を経由して外気を導入する換気方式の暖冷房負荷削減効果を評価するためには、以下の（1）～（4）のすべての要件を満たしていることが条件となります。</li>" +
            "<table><tbody>" +
            "<tr><th>(1)</th><td>地盤に接する床下空間を経由して外気を室内へ供給し、かつ、当該住戸全般の換気量を確保する第一種又は第二種換気設備を有していること。</td></tr>" +
            "<tr><th>(2)</th><td>基礎断熱工法を採用しており、かつ、床下空間における基礎等の底盤中央部分は、地盤面との熱交換の妨げとなる断熱材等を配置しないこと。</td></tr>" +
            "<tr><th>(3)</th><td><a href='/img/help/08_ip_ufv.pdf' target='_blank'>こちら</a>に記載されている熱交換型換気設備との併用は認めない</td></tr>" +
            "<tr><th>(4)</th><td>床下を構成する部材の劣化対策として、防腐・防蟻処理等を施す際には、人体に影響のある薬剤は使用せず、揮発性の低い薬剤等を選定するなどの配慮をすること。</td></tr>" +
            "</tbody></table>" +
            "<li>暖房の一部を空気集熱式太陽熱利用設備で賄う場合は「評価しない、または利用しない」を選択して下さい。</li></ul>",
    },
    ip_ufv_area_rate: {
        title: "外気が経由する床下の面積の割合",
        text: "<ul><li>床下空間全体の面積に対する外気を導入する床下空間の面積の割合になります。壁芯間の寸法により算出して下さい。" +
            "値は、100分の1未満の端数を切り下げた小数第二位までとし、パーセント単位（100倍して整数値）で入力して下さい。</li>" +
            "<li>ここで、外気が経由する空間とは、連続した一連の空間を指すこととし、人通口や通気口などの無い基礎立ち上り等で仕切られた空間の床面積は、外気が経由する床下の床面積には含みません。</li></ul>",
    },
    ip_ufv_dannetsu: {
        title: "床下空間の断熱",
        text: "<ul><li>床下の空間が熱的境界に囲まれた空間である場合は「断熱区画内」、そうでない場合は「断熱区画外」を選択して下さい。</li></ul>",
    },
    ip_yuka_dannetsu: {
        title: "住戸の種類の選択（断熱構造による住戸の種類）",
        text: "<ul><li>「床断熱住戸」とは、玄関等及び浴室を除いた部分の外皮を床とする住戸、" +
            "「基礎断熱住戸」とは、玄関等及び浴室を除いた部分の外皮を土間床等の外周部の基礎とする住戸のことです。</li></ul>",
    },
    ip_house_dannetsu: {
        title: "住戸の種類の選択（断熱構造による住戸の種類）",
        text: "<ul><li>「床断熱住戸」とは、玄関等及び浴室を除いた部分の外皮を床とする住戸、" +
            "「基礎断熱住戸」とは、玄関等及び浴室を除いた部分の外皮を土間床等の外周部の基礎とする住戸のことです。</li></ul>",
    },
    ip_heat_transmission_coefficient: {
        title: "熱貫流率と線熱貫流率",
        text: "<ol><li>熱貫流率<ul><li>当該住戸の外皮の各部位における熱貫流率の値とします。" +
            "各部位で複数の異なる仕様を有する場合は、熱貫流率に温度差係数を乗じた値が最も大きい部位の熱貫流率の値を入力して下さい。</li>" +
            "<li>窓の熱貫流率の計算において、窓の面積（当該窓が2以上の場合においてはその合計の面積）が単位住戸の床面積に0.02を乗じた数値以下となるものは計算対象から除くことができます。</li>" +
            "<li>床断熱住戸において浴室部分の外皮を床とする場合は、浴室の床の熱貫流率の値を入力し、浴室の床がない場合はその他の床の熱貫流率を浴室の床の熱貫流率として入力して下さい。</li>" +
            "<li>床断熱住戸において浴室部分の外皮を土間床等の外周部の基礎とする場合は、浴室の基礎の熱貫流率の値を入力し、" +
            "基礎断熱住戸においては、その他の基礎の熱貫流率を浴室の基礎の熱貫流率として入力して下さい。</li></ul></li>" +
            "<li>線熱貫流率<ul><li>当該住戸の外皮の各部位における線熱貫流率の値とします。各部位で複数の異なる仕様を有する場合は、" +
            "線熱貫流率に温度差係数を乗じた値が最も大きい部位の線熱貫流率の値を入力して下さい。</li>" +
            "<li>床断熱住戸において浴室部分の外皮を土間床等の外周部の基礎とする場合は、土間床等の外周部の線熱貫流率の値を入力し、" +
            "基礎断熱住戸においては、その他の土間床等の外周部の線熱貫流率を浴室の土間床等の外周部の線熱貫流率として入力して下さい。</li></ul></li></ol>",
    },
    ip_ss_eta_d_window: {
        title: "冷房期の窓の垂直日射熱取得率",
        text: "<ul><li>窓の垂直面日射熱取得率は、枠とガラスの種類の組み合わせにより、表1または表2に示す値から選択することができます。" +
            "あるいは、ガラスの垂直面日射熱取得率を用いて計算した値とすることもできます。</li>" +
            "<li>なお、複数の異なる仕様を有する場合は、窓の垂直面日射熱取得率が最も大きい部位の垂直面日射熱取得率の値を入力します。" +
            "その際に、窓の面積（当該窓が2以上の場合においては、その合計の面積）が単位住戸の床面積に0.04を乗じた数値以下となるものは計算対象から除くことができます。" +
            "<ol class='nomark'><li><span class='sumitsuki'>表1もしくは表2より読み取る</span><br>表1 枠が木製建具又は樹脂製建具の場合<br>" +
            "<img src='/img/help/ip_ss_eta_d_window_1.png' /><br>" +
            "表2 枠が木と金属の複合材料製建具、樹脂と金属の複合材料製建具、金属製熱遮断構造建具又は金属製建具の場合<br>" +
            "<img src='/img/help/ip_ss_eta_d_window_2.png' /></li>" +
            "<li><span class='sumitsuki'>ガラスの垂直面日射熱取得率を用いて計算する</span><ul><li>窓の垂直面日射熱取得率は、枠とガラスの種類の組み合わせにより、以下のように計算します。" +
            "<ol><li>枠が木製建具又は樹脂製建具の場合<br>η_(d,i)＝η_(g,i)×0.72</li>" +
            "<li>枠が木と金属の複合材料製建具、樹脂と金属の複合材料製建具、金属製熱遮断構造建具又は金属製建具の場合<br>η_(d,i)＝η_(g,i)×0.8</li>" +
            "<li>枠が木製建具又は樹脂製建具の場合<br>η_(d,i)＝η_(g,i)</li></ol><br>η_(d,i)：開口部𝑖の垂直面日射熱取得率<br>η_(g,i)：開口部𝑖のガラスの垂直面日射熱取得率</li>" +
            "<li>ガラスの垂直面日射熱取得率η_(g,i)は、以下のいずれかで確認した値を入力して下さい。<ol>" +
            "<li>JIS R3106（板ガラス類の透過率・反射率・放射率・日射熱取得率の試験方法）に定める値</li>" +
            "<li>ISO 9050（Glass in building ‒ Determination of light transmittance, solar direct transmittance," +
            " total solar energy transmittance, ultraviolet transmittance and related glazing factors）に定める値</li>" +
            "<li>下表に示す値<br>表3 ガラスの垂直面日射熱取得率<br><img src='/img/help/ip_ss_eta_d_window_3.png' /></li></ol>" +
            "<ol class='nomark'><li>注1）「単板ガラス2枚を組み合わせたもの」は、中間部にブラインドが設置されたものを含むものとする。</li>" +
            "<li>注2）日射取得型、日射遮蔽型の区分については、JIS R3106 の夏期の日射熱取得率の値が0.5以上のものを「日射取得型」、0.5未満のものを「日射遮蔽型」と判断する。" +
            "なお、ガラスの層数、ガラスの厚み、中空層厚み、Low-Eガラスの配置、中空層の気体の種類等によらず、" +
            "次に示す基本構成のLow-E複層ガラスの日射熱取得率の値で日射区分を判断してもよい。（以下、同じ。）<br>" +
            "基本構成のLow-E複層ガラス：[室内側]Low-Eガラス(3mm)＋空気層(12mm)＋透明フロート板ガラス(3mm)[室外側]</li></ol></li></ul></ol></li></ul>",
    },
    ip_sw_eta_d_window: {
        title: "暖房期の窓の垂直日射熱取得率",
        text: "<ul><li>窓の垂直面日射熱取得率は、枠とガラスの種類の組み合わせにより、表1または表2に示す値から選択することができます。" +
            "あるいは、ガラスの垂直面日射熱取得率を用いて計算した値とすることもできます。</li>" +
            "<li>なお、複数の異なる仕様を有する場合は、窓の垂直面日射熱取得率が最も小さい部位の垂直面日射熱取得率の値を入力します。" +
            "その際に、窓の面積（当該窓が2以上の場合においては、その合計の面積）が単位住戸の床面積に0.04を乗じた数値以下となるものは計算対象から除くことができます。" +
            "<ol class='nomark'><li><span class='sumitsuki'>表1もしくは表2より読み取る</span><br>表1 枠が木製建具又は樹脂製建具の場合<br>" +
            "<img src='/img/help/ip_sw_eta_d_window_1.png' /><br>" +
            "表2 枠が木と金属の複合材料製建具、樹脂と金属の複合材料製建具、金属製熱遮断構造建具又は金属製建具の場合<br>" +
            "<img src='/img/help/ip_sw_eta_d_window_2.png' /></li>" +
            "<li><span class='sumitsuki'>ガラスの垂直面日射熱取得率を用いて計算する</span><ul><li>窓の垂直面日射熱取得率は、枠とガラスの種類の組み合わせにより、以下のように計算します。" +
            "<ol><li>枠が木製建具又は樹脂製建具の場合<br>η_(d,i)＝η_(g,i)×0.72</li>" +
            "<li>枠が木と金属の複合材料製建具、樹脂と金属の複合材料製建具、金属製熱遮断構造建具又は金属製建具の場合<br>η_(d,i)＝η_(g,i)×0.8</li>" +
            "<li>枠が木製建具又は樹脂製建具の場合<br>η_(d,i)＝η_(g,i)</li></ol><br>η_(d,i)：開口部𝑖の垂直面日射熱取得率<br>η_(g,i)：開口部𝑖のガラスの垂直面日射熱取得率</li>" +
            "<li>ガラスの垂直面日射熱取得率η_(g,i)は、以下のいずれかで確認した値を入力して下さい。<ol>" +
            "<li>JIS R3106（板ガラス類の透過率・反射率・放射率・日射熱取得率の試験方法）に定める値</li>" +
            "<li>ISO 9050（Glass in building ‒ Determination of light transmittance, solar direct transmittance, " +
            "total solar energy transmittance, ultraviolet transmittance and related glazing factors）に定める値</li>" +
            "<li>下表に示す値<br>表3 ガラスの垂直面日射熱取得率<br><img src='/img/help/ip_sw_eta_d_window_3.png' /></li></ol>" +
            "<ol class='nomark'><li>注1）「単板ガラス2枚を組み合わせたもの」は、中間部にブラインドが設置されたものを含むものとする。</li>" +
            "<li>注2）日射取得型、日射遮蔽型の区分については、JIS R3106 の夏期の日射熱取得率の値が0.5以上のものを「日射取得型」、0.5未満のものを「日射遮蔽型」と判断する。" +
            "なお、ガラスの層数、ガラスの厚み、中空層厚み、Low-Eガラスの配置、中空層の気体の種類等によらず、" +
            "次に示す基本構成のLow-E複層ガラスの日射熱取得率の値で日射区分を判断してもよい。（以下、同じ。）<br>" +
            "基本構成のLow-E複層ガラス：[室内側]Low-Eガラス(3mm)＋空気層(12mm)＋透明フロート板ガラス(3mm)[室外側]</li></ol></li></ul></ol></li></ul>",
    },
    ip_window_f_input: {
        title: "窓の取得日射熱補正係数の指定方法",
        text: "<ul><li>地域、ガラスの種別並びに暖房期又は冷房期の別ごとに、ひさし等のオーバーハング型の日除けの効果を、ガラスの入射角特性及び地表面反射を考慮して定めた係数のことです。" +
            "規定値を用いない場合は、計算した値を入力することができます。</li></ul>",
    },
    ip_window_ss_f: {
        title: "冷房期の窓の取得日射熱補正係数",
        text: "<ul><li>窓の取得日射補正係数の計算方法は、<a href='/img/help/12_ip_window_f_input.pdf' target='_blank'>こちら</a>を参照して下さい。</li>" +
            "<li>冷房期の窓の取得日射熱補正係数は、当該住戸で最も大きい値を用いるか、又は、ガラス区分を1、開口部の上部に日除けが設置されていない場合として、" +
            "地域の区分に応じて、南西、北西、北東及び南東の値を" +
            "<a href='/img/help/12_ip_window_f_input.pdf' target='_blank'>こちら</a>により計算した値として下さい。</li></ul>",
    },
    ip_window_sw_f: {
        title: "暖房期の窓の取得日射熱補正係数",
        text: "<ul><li>窓の取得日射補正係数の計算方法は、<a href='/img/help/12_ip_window_f_input.pdf' target='_blank'>こちら</a>を参照して下さい。</li>" +
            "<li>暖房期の窓の取得日射熱補正係数は、当該住戸で最も小さい値を用いるか、または、ガラス区分を7、l<sub>1</sub>＝0、l<sub>2</sub>＝1/0.3として、" +
            "地域の区分に応じて、南西、北西、北東及び南東の値を" +
            "<a href='/img/help/12_ip_window_f_input.pdf' target='_blank'>こちら</a>により計算した値として下さい。</li></ul>",
    },
    hs_houhou: {
        title: "暖房方式",
        text: "<ul><li>暖房方式を「居室のみを暖房する」および「住戸全体を暖房する」に分類し、それぞれの方式に適用する暖房設備機器を設定します。" +
            "暖房設備機器を設置しない場合は「設置しない」を選択して下さい。<br>設置する暖房設備機器等の種類に応じた暖房方式及び運転方法の決定方法については、" +
            "<a href='/img/help/07_hs_houhou_20200714.pdf' target='_blank'>こちら</a>を参照して下さい。</li>" +
            "<li>暖房設備機器を「設置しない」を選択した場合は、地域の区分や建て方に応じて予め定められた" +
            "暖房方式及び暖房設備機器により暖房するものと想定した一次エネルギー消費量が計算されます。</li></ul>",
    },
    hs_type_1: {
        title: "住戸全体を暖房する／暖房設備機器の種類",
        text: "<ul><li>「住戸全体を暖房する」は、ヒートポンプを熱源とし、機外静圧を持った状態で運転されることを想定して、" +
            "ダクト等により住戸全体を空調するように計画された家庭用のダクト式セントラル空調（循環用送風機が室内機と一体となっているもの）で暖房する場合のみ選択することができます。" +
            "なお、クローゼットや納戸等の一部の空間を除いた非居室を含め、住宅全体を1以上のダクト式セントラル空調で暖房する場合も評価の対象となります。</li>" +
            "<li>ヒートポンプ式熱源でないダクト式セントラル空調機を評価する場合は、以下の手順で条件を入力して計算して下さい。" +
            "<ol><li>「暖房方式」で「居室のみを暖房する」を選択して下さい。</li>" +
            "<li>「主たる居室」および「その他の居室」に、「暖房設備機器または放熱器を設置しない」または「その他の暖房設備機器」を選択して下さい。</li>" +
            "<li>「その他の暖房設備機器」を選択した場合は、「主たる居室」および「その他の居室」に同じ機器名称を入力して下さい。</li></ol></li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、以下の方法で能力や係数を求め、評価して下さい。" +
            "<ol style='list-style-type:upper-alpha;'><li>「定格暖房能力」は、設置する複数の機器の定格暖房能力を合計した値として下さい。</li>" +
            "<li>「定格暖房消費電力」は、1.で合計した定格暖房能力を設置する機器のうち最も低い定格暖房エネルギー消費効率で除した値として下さい。</li>" +
            "<li>「暖房時におけるダクト等圧力損失による消費電力量補正係数」は、設置する複数の機器の暖房時における" +
            "ダクト等圧力損失による消費電力量補正係数のうち、最も大きい値として下さい。</li></ol></li></ul>",
    },
    hs_type_2: {
        title: "居室のみを暖房する／暖房設備機器または放熱器の種類",
        text: "<ul><li>「居室のみを暖房する」を選択した場合は、「主たる居室」と「その他の居室」ごとに、設置する暖房設備機器等を選択して下さい。</li>" +
            "<li>暖房設備機器等を設置しない場合は、「設置しない」を選択して下さい。" +
            "それぞれの居室で選択した暖房設備機器等より、機器に応じた運転方法に対応した暖房負荷に基づき、暖房設備の一次エネルギー消費量を計算します。</li>" +
            "<li>設備機器等を設置しない場合、あるいは複数の設備機器等を設置する場合の運転方法の決定方法については、" +
            "<a href='/img/help/07_hs_houhou_20200714.pdf' target='_blank'>こちら</a>を参照して下さい。</li>" +
            "<li>「パネルラジエーター」、「温水床暖房」、「ファンコンベクター」を選択した場合は、画面下にある「温水式暖房を設置する場合」における入力項目も入力して下さい。</li></ul>",
    },
    hs_ldk_aircon_houhou: {
        title: "エネルギー消費効率の入力（ルームエアコンディショナー）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。" +
            "ルームエアコンディショナーを居住者が設置予定などで、設置される機器が特定されない場合もこちらを選択して下さい。</li>" +
            "<li>「入力する」は、エネルギー消費効率の区分によって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    hs_ldk_ff_houhou: {
        title: "エネルギー消費効率の入力（FF暖房機）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。" +
            "設置される機器のエネルギー消費効率が不明な場合もこちらを選択して下さい。</li>" +
            "<li>「入力する」は、定格能力におけるエネルギー消費効率（熱効率）を入力することによって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    hs_ldk_yuka_fusetsu: {
        title: "温水床暖房（敷設率）",
        text: "<ul><li>床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力します。" +
            "「その他の居室」で床暖房を設置する場合も、床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。<br>" +
            "敷設率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>こちら（10）</a>を参照して下さい。</li></ul>",
    },
    hs_ldk_yuka_fukinuke: {
        title: "仮想床の床面積を除いた敷設率",
        text: "<ul><li>「主たる居室」に吹抜けを有する場合に、仮想床の床面積を除いた敷設率を入力することができます。" +
            "ただし、温水床暖房が設置される「主たる居室」が2か所以上ある場合は、その全ての主たる居室に吹抜けがある場合に限ります。" +
            "「主たる居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。</li>" +
            "<li>「吹抜け」とは、複数の階をまたいで床を設けず上下方向に連続した空間を指します。" +
            "「仮想床」とは、天井の高さが4.2以上の場合に、高さ2.1mの部分に仮想床があるものとみなし、以下同様に、天井高さが 2.1m 増えるごとに仮想床があるとします。</li></ul>",
    },
    hs_ldk_yuka_dannetsu: {
        title: "上面放熱率（床の断熱）（温水床暖房）",
        text: "<ul><li>「床下側を断熱することにより、床下側への熱損失を減らすことができます。" +
            "上面放熱率とは、床暖房パネルに投入した熱量に対する居室（上部）に放熱される熱量の割合を示し、ここでは、居室（上部）と床下等（下部）の温度は等しいと想定しています。</li>" +
            "<li>「主たる居室」において2か所以上に温水床暖房を設置する場合、又は「その他の居室」において 2か所以上に温水床暖房を設置する場合の上面放熱率は、それぞれの箇所で計算した値のうち、最も小さい値を入力して下さい。" +
            "<ol><li>「主たる居室」の2ヶ所以上に温水床暖房が設置される場合</li>" +
            "<li>「その他の居室」の2ヶ所以上に温水床暖房が設置される場合</li>" +
            "<li> 複数の「その他の居室」においてそれぞれに温水床暖房が設置される場合</li></ol></li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "上面放熱率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>「エネルギー消費性能の算定方法」</a>の「4 暖冷房設備　7 温水暖房付録L 温水床暖房」を参照して下さい。",
        },
    },
    hs_ldk_heater_fusetsu: {
        title: "電気ヒーター床暖房（敷設率）",
        text: "<ul><li>床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。</li>" +
            "<li>「その他の居室」で床暖房を設置する場合も、床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。" +
            "敷設率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>こちら（4章5節）</a>を参照して下さい。</li>" +
            "<li>「主たる居室」の 2 ヶ所以上に温水床暖房が設置される場合、「その他の居室」の 2 ヶ所以上に電気ヒーター式床暖房が設置される場合、又は複数の「その他の居室」において" +
            "それぞれに電気ヒーター式床暖房が設置される場合、「主たる居室」及び「その他の居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。" +
            "ただし、当面の間、従前の方法（当該住戸の敷設面積の合計を、電気ヒーター式床暖房を設置する居室の床面積の合計で除した値を、敷設率とする方法）も用いることができます。</li>" +
            "<li>電気ヒーター式床暖房と温水床暖房又はルームエアコンディショナー付床暖房が「主たる居室」及び「その他の居室」に併設される場合は、電気ヒーター式床暖房の床暖房パネルのみによる敷設率を求めて下さい。</li></ul>",
    },
    hs_ldk_heater_fukinuke: {
        title: "仮想床の床面積を除いた敷設率",
        text: "<ul><li>「主たる居室」に吹抜けを有する場合に、仮想床の床面積を除いた敷設率を入力することができます。" +
            "ただし、電気ヒーター式床暖房が設置される「主たる居室」が2か所以上ある場合は、その全ての主たる居室に吹抜けがある場合に限ります。" +
            "「主たる居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。</li>" +
            "<li>「吹抜け」とは、複数の階をまたいで床を設けず上下方向に連続した空間を指します。" +
            "「仮想床」とは、天井の高さが4.2以上の場合に、高さ2.1mの部分に仮想床があるものとみなし、以下同様に、天井高さが 2.1m 増えるごとに仮想床があるとします。</li></ul>",
    },
    hs_ldk_heater_dannetsu: {
        title: "上面放熱率（床の断熱）（電気ヒーター床暖房）",
        text: "<ul><li>床下側を断熱することにより、床下側への熱損失を減らすことができます。" +
            "上面放熱率とは、床暖房パネルに投入した熱量に対する居室（上部）に放熱される熱量の割合を示し、ここでは、居室（上部）と床下等（下部）の温度は等しいと想定しています。</li>" +
            "<li>なお、電気ヒーター床暖房が2ヶ所以上に設置される以下のような場合は、「主たる居室」及び「その他の居室」のそれぞれにおいて上面放熱率を計算し、そのうち最も小さい値を上面放熱率として入力してください。" +
            "<ol><li>「主たる居室」の2ヶ所以上に電気ヒーター床暖房が設置される場合</li>" +
            "<li>「その他の居室」の2ヶ所以上に電気ヒーター床暖房が設置される場合</li>" +
            "<li> 複数の「その他の居室」においてそれぞれに電気ヒーター床暖房が設置される場合</li></ol></li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "上面放熱率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>「エネルギー消費性能の算定方法」</a>の「4 暖冷房設備　5 電気ヒーター床暖房付録A 機器の性能を表す仕様の決定方法」を参照して下さい。",
        },
    },
    hs_ldk_racfh_fusetsu: {
        title: "ルームエアコンディショナー付温水床暖房機（敷設率）",
        text: "<ul><li>床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。<br>" +
            "「その他の居室」で床暖房を設置する場合も、床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。" +
            "敷設率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>こちら（11）</a>を参照して下さい。</li>" +
            "<li>「主たる居室」の 2 ヶ所以上に温水床暖房が設置される場合、「その他の居室」の 2 ヶ所以上にルームエアコンディショナー付床暖房が設置される場合、" +
            "又は複数の「その他の居室」においてそれぞれにルームエアコンディショナー付床暖房が設置される場合、「主たる居室」及び「その他の居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。" +
            "ただし、当面の間、従前の方法（当該住戸の敷設面積の合計を、ルームエアコンディショナー付床暖房を設置する居室の床面積の合計で除した値を敷設率とする方法）も用いることができます。</li>" +
            "<li>ルームエアコンディショナー付床暖房と温水床暖房又は電気ヒーター式床暖房が「主たる居室」及び「その他の居室」に併設される場合は、" +
            "ルームエアコンディショナー付床暖房の床暖房パネルのみによる敷設率を求めて下さい。</li></ul>",
    },
    hs_ldk_racfh_fukinuke: {
        title: "仮想床の床面積を除いた敷設率",
        text: "<ul><li>「主たる居室」に吹抜けを有する場合に、仮想床の床面積を除いた敷設率を入力することができます。" +
            "ただし、ルームエアコンディショナー付床暖房が設置される「主たる居室」が2か所以上ある場合は、その全ての主たる居室に吹抜けがある場合に限ります。" +
            "「主たる居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。</li>" +
            "<li>「吹抜け」とは、複数の階をまたいで床を設けず上下方向に連続した空間を指します。" +
            "「仮想床」とは、天井の高さが4.2以上の場合に、高さ2.1mの部分に仮想床があるものとみなし、以下同様に、天井高さが 2.1m 増えるごとに仮想床があるとします。</li></ul>",
    },
    hs_ldk_racfh_dannetsu: {
        title: "上面放熱率（床の断熱）（ルームエアコンディショナー付温水床暖房機）",
        text: "<ul><li>床下側を断熱することにより、床下側への熱損失を減らすことができます。" +
            "上面放熱率とは、床暖房パネルに投入した熱量に対する居室（上部）に放熱される熱量の割合を示し、ここでは、居室（上部）と床下等（下部）の温度は等しいと想定しています。</li>" +
            "<li>なお、ルームエアコンディショナー付床暖房が2ヶ所以上に設置される以下のような場合は、" +
            "「主たる居室」及び「その他の居室」のそれぞれにおいて上面放熱率を計算し、そのうち最も小さい値を上面放熱率として入力してください。" +
            "<ol><li>「主たる居室」の2ヶ所以上にルームエアコンディショナー付床暖房が設置される場合</li>" +
            "<li>「その他の居室」の2ヶ所以上にルームエアコンディショナー付床暖房が設置される場合</li>" +
            "<li>複数の「その他の居室」においてそれぞれにルームエアコンディショナー付床暖房が設置される場合</li></ol></li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "上面放熱率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>「エネルギー消費性能の算定方法」</a>の「4 暖冷房設備　7 温水暖房付録L 温水床暖房」を参照して下さい。",
        },
    },
    hs_ldk_racfh_dannetsu_haikan: {
        title: "断熱配管（ルームエアコンディショナー付温水床暖房機）",
        text: "<ul><li>温水暖房機から放熱器までの温水配管における熱損失の状況を評価します。温水配管の周囲を断熱材で被覆している場合は、「採用する」を選択して下さい。</li>" +
            "<li>断熱材の種類・厚さは問いませんが、温水暖房機から放熱器まで全部が断熱されていることが要件となります。なお、サヤ管等にできる空気層については、断熱材とは認めません。</li>" +
            "<li>上記以外の場合は「評価しない、または採用しない」を選択して下さい。</li></ul>",
    },
    hs_ldk_type: {
        title: "居室のみを暖房する／暖房設備機器または放熱器の種類",
        text: "<ul><li>「居室のみを暖房する」を選択した場合は、「主たる居室」と「その他の居室」ごとに、設置する暖房設備機器等を選択して下さい。</li>" +
            "<li>暖房設備機器等を設置しない場合は、「設置しない」を選択して下さい。" +
            "それぞれの居室で選択した暖房設備機器等より、機器に応じた運転方法に対応した暖房負荷に基づき、暖房設備の一次エネルギー消費量を計算します。</li>" +
            "<li>設備機器等を設置しない場合、あるいは複数の設備機器等を設置する場合の運転方法の決定方法については、" +
            "<a href='/img/help/07_hs_houhou_20200714.pdf' target='_blank'>こちら</a>を参照して下さい。</li>" +
            "<li>「パネルラジエーター」、「温水床暖房」、「ファンコンベクター」を選択した場合は、画面下にある「温水式暖房を設置する場合」における入力項目も入力して下さい。</li></ul>",
    },
    hs_ldk_aircon_koukouritsu: {
        title: "エネルギー消費効率の区分（ルームエアコンディショナー）",
        text: "<ul><li>エネルギー消費効率の区分とは、冷房定格能力の大きさごとに定格冷房エネルギー消費効率の程度に応じて三段階に区分したものです。</li>" +
            "<li>暖房運転についても「冷房定格能力」と「定格冷房エネルギー消費効率」に基づき、エネルギー消費効率の区分を設定していることに注意して下さい。</li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "エネルギー消費効率の区分の確認方法は、「<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>設計一次エネルギー消費量算定方法</a>」 の" +
                "「4　暖冷房設備　4-3ルームエアコンディショナー　付録A 機器の性能を表す仕様の決定方法」を参照して下さい。",
        },
    },
    hs_ldk_aircon_dualcompressor: {
        title: "小能力時高効率型コンプレッサー（ルームエアコンディショナー）",
        text: "<ul><li>小能力時高効率型コンプレッサーとは、概ね中間能力（定格能力の1/2）以下の小能力で運転する時、コンプレッサーのシリンダ容積を小さくする容量可変機構、" +
            "あるいは冷媒の漏れを防ぐシリンダの機構を有し、高効率かつ連続運転を可能にしたコンプレッサーのことです。</li>" +
            "<li>小能力時高効率型コンプレッサーの搭載については、カタログやメーカーWEBサイト等でご確認下さい。</li>" +
            "<li>複数のルームエアコンディショナーが設置される場合で、小能力時高効率型コンプレッサーの搭載の有無が異なる場合は、「搭載しない」を選択して下さい。</li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "エネルギー消費効率の区分の確認方法は、「<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>設計一次エネルギー消費量算定方法</a>」 の" +
                "「4　暖冷房設備　4-3ルームエアコンディショナー　付録B 小能力時高効率型コンプレッサー搭載ルームエアコンディショナーの定義と判別方法」を参照して下さい。",
        },
    },
    hs_nldk_type: {
        title: "居室のみを暖房する／暖房設備機器または放熱器の種類",
        text: "<ul><li>「居室のみを暖房する」を選択した場合は、「主たる居室」と「その他の居室」ごとに、設置する暖房設備機器等を選択して下さい。</li>" +
            "<li>暖房設備機器等を設置しない場合は、「設置しない」を選択して下さい。それぞれの居室で選択した暖房設備機器等より、機器に応じた運転方法に対応した暖房負荷に基づき、" +
            "暖房設備の一次エネルギー消費量を計算します。</li>" +
            "<li>設備機器等を設置しない場合、あるいは複数の設備機器等を設置する場合の運転方法の決定方法については、" +
            "<a href='/img/help/07_hs_houhou_20200714.pdf' target='_blank'>こちら</a>を参照して下さい。</li>" +
            "<li>「パネルラジエーター」、「温水床暖房」、「ファンコンベクター」を選択した場合は、画面下にある「温水式暖房を設置する場合」における入力項目も入力して下さい。</li></ul>",
    },
    hs_nldk_aircon_houhou: {
        title: "エネルギー消費効率の入力（ルームエアコンディショナー）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。" +
            "ルームエアコンディショナーを居住者が設置予定などで、設置される機器が特定されない場合もこちらを選択して下さい。</li>" +
            "<li>「入力する」は、エネルギー消費効率の区分によって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    hs_nldk_aircon_koukouritsu: {
        title: "エネルギー消費効率の区分（ルームエアコンディショナー）",
        text: "<ul><li>エネルギー消費効率の区分とは、冷房定格能力の大きさごとに定格冷房エネルギー消費効率の程度に応じて三段階に区分したものです。</li>" +
            "<li>暖房運転についても「冷房定格能力」と「定格冷房エネルギー消費効率」に基づき、エネルギー消費効率の区分を設定していることに注意して下さい。</li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "エネルギー消費効率の区分の確認方法は、「<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>設計一次エネルギー消費量算定方法</a>」 の" +
                "「4　暖冷房設備　4-3ルームエアコンディショナー　付録A 機器の性能を表す仕様の決定方法」を参照して下さい。",
        },
    },
    hs_nldk_aircon_dualcompressor: {
        title: "小能力時高効率型コンプレッサー（ルームエアコンディショナー）",
        text: "<ul><li>小能力時高効率型コンプレッサーとは、概ね中間能力（定格能力の1/2）以下の小能力で運転する時、コンプレッサーのシリンダ容積を小さくする容量可変機構、" +
            "あるいは冷媒の漏れを防ぐシリンダの機構を有し、高効率かつ連続運転を可能にしたコンプレッサーのことです。</li>" +
            "<li>小能力時高効率型コンプレッサーの搭載については、カタログやメーカーWEBサイト等でご確認下さい。</li>" +
            "<li>複数のルームエアコンディショナーが設置される場合で、小能力時高効率型コンプレッサーの搭載の有無が異なる場合は、「搭載しない」を選択して下さい。</li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "小能力時高効率型コンプレッサー搭載ルームエアコンディショナーの定義や判別方法については、「<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>" +
                "設計一次エネルギー消費量算定方法</a>」 の「4　暖冷房設備　4-3ルームエアコンディショナー　付録B 小能力時高効率型コンプレッサー搭載ルームエアコンディショナーの定義と判別方法」を参照して下さい。",
        },
    },
    hs_nldk_ff_houhou: {
        title: "エネルギー消費効率の入力（FF暖房機）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。" +
            "設置される機器のエネルギー消費効率が不明な場合もこちらを選択して下さい。</li>" +
            "<li>「入力する」は、定格能力におけるエネルギー消費効率（熱効率）を入力することによって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    hs_nldk_yuka_fusetsu: {
        title: "温水床暖房（敷設率）",
        text: "<ul><li>床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力します。" +
            "「その他の居室」で床暖房を設置する場合も、床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。<br>" +
            "敷設率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>こちら（10）</a>を参照して下さい。</li>" +
            "<li>「主たる居室」の 2 ヶ所以上に温水床暖房が設置される場合、「その他の居室」の 2 ヶ所以上に温水床暖房が設置される場合、又は複数の「その他の居室」においてそれぞれに温水床暖房が設置される場合、" +
            "「主たる居室」及び「その他の居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。ただし、当面の間、従前の方法（当該住戸の敷設面積の合計を、" +
            "温水床暖房を設置する居室の床面積の合計で除した値を、敷設率とする方法）も用いることができます。</li>" +
            "<li>温水床暖房と電気ヒーター式床暖房又はルームエアコンディショナー付床暖房が「主たる居室」及び「その他の居室」に併設される場合は、温水床暖房の床暖房パネルのみによる敷設率を求めて下さい。</li></ul>",
    },
    hs_nldk_yuka_dannetsu: {
        title: "上面放熱率（床の断熱）（温水床暖房）",
        text: "<ul><li>床下側を断熱することにより、床下側への熱損失を減らすことができます。" +
            "上面放熱率とは、床暖房パネルに投入した熱量に対する居室（上部）に放熱される熱量の割合を示し、ここでは、居室（上部）と床下等（下部）の温度は等しいと想定しています。</li>" +
            "<li>「主たる居室」において2か所以上に温水床暖房を設置する場合、又は「その他の居室」において 2か所以上に温水床暖房を設置する場合の上面放熱率は、それぞれの箇所で計算した値のうち、最も小さい値を入力して下さい。" +
            "<ol><li>「主たる居室」の2ヶ所以上に温水床暖房が設置される場合</li>" +
            "<li>「その他の居室」の2ヶ所以上に温水床暖房が設置される場合</li>" +
            "<li> 複数の「その他の居室」においてそれぞれに温水床暖房が設置される場合</li></ol></li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "上面放熱率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>「エネルギー消費性能の算定方法」</a>の「4 暖冷房設備　7 温水暖房付録L 温水床暖房」を参照して下さい。",
        },
    },
    hs_nldk_heater_fusetsu: {
        title: "電気ヒーター床暖房（敷設率）",
        text: "<ul><li>床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。</li>" +
            "<li>「その他の居室」で床暖房を設置する場合も、床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。" +
            "敷設率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>こちら（11）</a>を参照して下さい。</li>" +
            "<li>「主たる居室」の 2 ヶ所以上に温水床暖房が設置される場合、「その他の居室」の 2 ヶ所以上に電気ヒーター式床暖房が設置される場合、" +
            "又は複数の「その他の居室」においてそれぞれに電気ヒーター式床暖房が設置される場合、「主たる居室」及び「その他の居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。" +
            "ただし、当面の間、従前の方法（当該住戸の敷設面積の合計を、電気ヒーター式床暖房を設置する居室の床面積の合計で除した値を、敷設率とする方法）も用いることができます。</li>" +
            "<li>電気ヒーター式床暖房と温水床暖房又はルームエアコンディショナー付床暖房が「主たる居室」及び「その他の居室」に併設される場合は、電気ヒーター式床暖房の床暖房パネルのみによる敷設率を求めて下さい。</li></ul>",
    },
    hs_nldk_heater_dannetsu: {
        title: "上面放熱率（床の断熱）（電気ヒーター床暖房）",
        text: "<ul><li>床下側を断熱することにより、床下側への熱損失を減らすことができます。" +
            "上面放熱率とは、床暖房パネルに投入した熱量に対する居室（上部）に放熱される熱量の割合を示し、ここでは、居室（上部）と床下等（下部）の温度は等しいと想定しています。</li>" +
            "<li>なお、電気ヒーター床暖房が2ヶ所以上に設置される以下のような場合は、「主たる居室」及び「その他の居室」のそれぞれにおいて上面放熱率を計算し、そのうち最も小さい値を上面放熱率として入力してください。" +
            "<ol><li>「主たる居室」の2ヶ所以上に電気ヒーター床暖房が設置される場合</li>" +
            "<li>「その他の居室」の2ヶ所以上に電気ヒーター床暖房が設置される場合</li>" +
            "<li> 複数の「その他の居室」においてそれぞれに電気ヒーター床暖房が設置される場合</li></ol></li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "上面放熱率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>「エネルギー消費性能の算定方法」</a>の「4 暖冷房設備　5 電気ヒーター床暖房付録A 機器の性能を表す仕様の決定方法」を参照して下さい。",
        },
    },
    hs_nldk_racfh_fusetsu: {
        title: "ルームエアコンディショナー付温水床暖房機（敷設率）",
        text: "<ul><li>床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。<br>" +
            "「その他の居室」で床暖房を設置する場合も、床暖房を設置する居室における床暖房パネルの敷設面積を当該居室の床面積で除した値を入力して下さい。" +
            "敷設率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>こちら（11）</a>を参照して下さい。</li>" +
            "<li>「主たる居室」の 2 ヶ所以上に温水床暖房が設置される場合、「その他の居室」の 2 ヶ所以上にルームエアコンディショナー付床暖房が設置される場合、" +
            "又は複数の「その他の居室」においてそれぞれにルームエアコンディショナー付床暖房が設置される場合、「主たる居室」及び「その他の居室」それぞれにおいて敷設率を計算した値のうち、最も小さい値を入力して下さい。" +
            "ただし、当面の間、従前の方法（当該住戸の敷設面積の合計を、ルームエアコンディショナー付床暖房を設置する居室の床面積の合計で除した値を敷設率とする方法）も用いることができます。</li>" +
            "<li>ルームエアコンディショナー付床暖房と温水床暖房又は電気ヒーター式床暖房が「主たる居室」及び「その他の居室」に併設される場合は、" +
            "ルームエアコンディショナー付床暖房の床暖房パネルのみによる敷設率を求めて下さい。</li></ul>",
    },
    hs_nldk_racfh_dannetsu: {
        title: "上面放熱率（床の断熱）（ルームエアコンディショナー付温水床暖房機）",
        text: "<ul><li>床下側を断熱することにより、床下側への熱損失を減らすことができます。" +
            "上面放熱率とは、床暖房パネルに投入した熱量に対する居室（上部）に放熱される熱量の割合を示し、ここでは、居室（上部）と床下等（下部）の温度は等しいと想定しています。</li>" +
            "<li>なお、ルームエアコンディショナー付床暖房が2ヶ所以上に設置される以下のような場合は、" +
            "「主たる居室」及び「その他の居室」のそれぞれにおいて上面放熱率を計算し、そのうち最も小さい値を上面放熱率として入力してください。" +
            "<ol><li>「主たる居室」の2ヶ所以上にルームエアコンディショナー付床暖房が設置される場合</li>" +
            "<li>「その他の居室」の2ヶ所以上にルームエアコンディショナー付床暖房が設置される場合</li>" +
            "<li>複数の「その他の居室」においてそれぞれにルームエアコンディショナー付床暖房が設置される場合</li></ol></li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "上面放熱率の計算方法は、<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>「エネルギー消費性能の算定方法」</a>の「4 暖冷房設備　7 温水暖房付録L 温水床暖房」を参照して下さい。",
        },
    },
    hs_nldk_racfh_dannetsu_haikan: {
        title: "断熱配管（ルームエアコンディショナー付温水床暖房機）",
        text: "<ul><li>温水暖房機から放熱器までの温水配管における熱損失の状況を評価します。温水配管の周囲を断熱材で被覆している場合は、「採用する」を選択して下さい。</li>" +
            "<li>断熱材の種類・厚さは問いませんが、温水暖房機から放熱器まで全部が断熱されていることが要件となります。なお、サヤ管等にできる空気層については、断熱材とは認めません。</li>" +
            "<li>上記以外の場合は「評価しない、または採用しない」を選択して下さい。</li></ul>",
    },
    hs_onsuiyuka_netsugen: {
        title: "温水暖房機の種類",
        text: "<ul><li>温水暖房の放熱器のみに接続される「温水暖房専用型」と、台所、洗面、浴室などへの給湯用熱源を兼ねる「給湯・温水暖房一体型」、" +
            "温水の供給に加えて発電も行う「コージェネレーション」などがあります。</li></ul>",
    },
    hs_onsuiyuka_netsugen_senyo: {
        title: "温水暖房専用型",
        text: "<ul><li>各居室に設置された放熱器と循環配管で1対1又は1対多で接続する温水暖房用の熱源機です。</li></ul>",
    },
    hs_onsuiyuka_netsugen_2: {
        title: "給湯・温水暖房一体型を使用する",
        text: "<ul><li>温水暖房用の放熱器への温水供給と、台所、洗面、浴室で使用する湯を供給する熱源機が一体型のものを使用する場合に選択して下さい。</li>" +
            "<li>「給湯・温水暖房一体型」を使用する場合は、「給湯」で詳細な仕様を入力します。</li></ul>",
    },
    hs_onsuiyuka_netsugen_3: {
        title: "コージェネレーションを使用する",
        text: "<ul><li>温水暖房用の放熱器への温水供給を、コージェネレーションシステムによって行う場合に選択して下さい。</li></ul>",
    },
    hs_onsuiyuka_gas1_houhou: {
        title: "エネルギー消費効率の入力（ガス従来型温水暖房機）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。</li>" +
            "<li>「入力する」は、定格能力におけるエネルギー消費効率（熱効率）を入力することによって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    hs_onsuiyuka_dannnetu: {
        title: "断熱配管",
        text: "<ul><li>温水暖房機から放熱器までの温水配管における熱損失の状況を評価します。温水配管の周囲を断熱材で被覆している場合は、「採用する」を選択して下さい。</li>" +
            "<li>断熱材の種類・厚さは問いませんが、温水暖房機から放熱器まで全部が断熱されていることが要件となります。なお、サヤ管等にできる空気層については、断熱材とは認めません。</li>" +
            "<li>上記以外の場合は「評価しない、または採用しない」を選択して下さい。</li></ul>",
    },
    hs_onsuiyuka_dannnetu_kukaku: {
        title: "配管が通過する空間",
        text: "<ul><li>温水暖房用熱源機と放熱器（床暖房・パネルラジエーター・ファンコンベクター）をつなぐ配管からの熱損失は、配管の断熱被覆の度合いや配管が通過する空間の温度によってその大きさが決まります。" +
            "ここでは配管の周囲温度の想定のため、配管が通る空間を指定します。</li>" +
            "<li>温水暖房用熱源機から各居室に設置する放熱器までの全ての配管が断熱区画内外のいずれかにあるのかを確認してください。</li>" +
            "<li>ここで、断熱区画内とは、断熱材等の連続した熱的境界の内側の部分を言い、戸建て住宅における階間や基礎断熱住宅の床下、集合住宅が該当します。</li>" +
            "<li>温水暖房用熱源機が基礎断熱住宅の屋外や集合住宅における屋外共用部等の断熱区画外に設置される場合、温水暖房用熱源機と配管の接続口から断熱区画境界までの配管は、断熱区画内にあるとみなします。" +
            "ただし、熱源機が1階にあり断熱区画境界が2階にある場合等、断熱区画外の配管長が極めて長くなる場合は、断熱被覆を施していることが要件となります。</li></ul>",
    },
    hs_onsuiyuka_gas2_houhou: {
        title: "エネルギー消費効率の入力（ガス潜熱回収型温水暖房機）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。</li>" +
            "<li>「入力する」は、定格能力におけるエネルギー消費効率（熱効率）を入力することによって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    hs_onsuiyuka_oil_houhou: {
        title: "エネルギー消費効率の入力（石油従来型温水暖房機）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。</li>" +
            "<li>「入力する」は、定格能力におけるエネルギー消費効率（熱効率）を入力することによって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    hs_onsuiyuka_hp_netsukoukan: {
        title: "熱交換器タイプ",
        text: "<ul><li>確認シートなどを用いて事前に熱交換器タイプを決定し、入力して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "熱交換器タイプの確認方法については、「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の" +
                "「第四章 暖冷房設備」「第七節 温水暖房」の「付録O 地中熱ヒートポンプ温水暖房機の熱交換器タイプの決定方法」を参照して下さい。",
        },
    },
    hs_dc_duct_dannnetu: {
        title: "ダクトが通過する空間",
        text: "<ul><li>ダクトが通過する空間が熱的境界に囲まれた空間である場合は「断熱区画内」、そうでない場合は「断熱区画外」を選択してください。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器において「全て断熱区画内である」場合は「全て断熱区画内である」を選択して下さい。" +
            "それ以外の場合は、「評価しない、または全てもしくは一部が断熱区画外である」を選択して下さい。</li></ul>",
    },
    hs_dc_vav: {
        title: "VAV方式",
        text: "<ul><li>空調機から居室までのダクト経路上に、ダンパ又はファンを配置して、居室の暖冷房負荷に応じて自動制御により送風量を増減する方式です。</li>" +
            "<li>以下の２つの要件を満たす場合は、「採用する」を選択して下さい。それ以外の場合は、「評価しない、または採用しない」を選択して下さい。" +
            "<ol><li>次の制御・機能を有する機器であり、すべての居室ごとに、その居室で発生する冷暖房負荷に合わせて、風量を調整できること。" +
            "<ul><li>すべての居室ごとに、ダクト経路の端末もしくは途中にダンパーやファンを設置して、居室ごとに発生する冷暖房負荷に応じて、吹出風量を制御できること。</li>" +
            "<li>すべての居室に温度センサーが設置され、設定温度とセンサー検知温度の差に応じた制御を行うなど、自動で吹出風量を制御することができること。</li>" +
            "<li>全般換気（24時間換気）の機能を有する機器の場合は、温度調節が達成しても完全にダンパーが閉鎖もしくはファンが停止せず、全般換気（24時間換気）用の吹出風量を確保できる機能を有すること。</li></ul></li>" +
            "<li>内機に次の機能がある機器であり、すべての居室ごとに風量を調整できるとともに、それに合わせて室内機の循環風量（全体風量）を調整できること。" +
            "<ul><li>各居室の風量もしくは室温は、システム制御にフィードバックされ、室内機本体でもインバーターやノッチで全体風量が調整でき、各居室で必要とされる風量の合計に調節できること。</li></ul></li></ol></li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器において「採用する」の場合は「採用する」を選択して下さい。それ以外の場合は「評価しない、または採用しない」を選択して下さい。</li></ul>",
    },
    hs_dc_general_ventilation: {
        title: "全般換気機能",
        text: "<ul><li>全般換気機能とは、給気もしくは還気経路において新鮮外気を導入し、室内空気汚染物質の排出を目的として住宅全体または居室を対象として換気を行う機能です。</li>" +
            "<li>給気および還気経路において新鮮外気を導入していない場合は、「評価しない、または全般換気機能なし」を選択して下さい。それ以外の場合は、「全般換気機能あり」を選択して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器において「評価しない、または全般換気機能なし」の場合は「評価しない、または全般換気機能なし」を選択して下さい。" +
            "それ以外の場合は「全般換気機能あり」を選択して下さい。</li></ul>",
    },
    hs_dc_input: {
        title: "機器の仕様の入力",
        text: "<ul><li>「定格暖房能力試験の値」とは、JIS B8616が定める定格暖房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる能力および消費電力、ならびに、室内側及び室外側の送風機の風量を" +
            "JIS B8615-2が定める空調機の性能試験による定格暖房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した室内側送風機の風量および消費電力です。</li>" +
            "<li>「中間暖房能力試験の値」とは、JIS B8616が定める中間暖房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる能力および消費電力、ならびに、室内側及び室外側の送風機の風量を" +
            "JIS B8615-2が定める空調機の性能試験による中間暖房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した室内側送風機の風量および消費電力です。</li>" +
            "<li>但し、室内側送風機の風量および消費電力については、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、次の通り選択して下さい。" +
            "<ol><li>すべての機器が「定格能力試験と中間能力試験の値を入力する」に該当する場合、は「定格能力試験と中間能力試験の値を入力する」を選択して下さい。</li>" +
            "<li>上記の1.に該当しない場合で、すべての機器が「定格能力試験の値を入力する」に該当する場合は「定格能力試験の値を入力する」を選択して下さい。</li>" +
            "<li>上記1.にも2.にもあてはまらない場合は、「入力しない（規定値を用いる）」を選択して下さい。</li></ol></li></ul>",
    },
    hs_dc_rated_capacity: {
        title: "定格暖房能力試験の値（能力）",
        text: "<ul><li>JIS B8616が定める定格暖房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「定格暖房能力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格暖房能力」の合計値を入力して下さい。</li></ul>",
    },
    hs_dc_rated_power: {
        title: "定格暖房能力試験の値（消費電力）",
        text: "<ul><li>JIS B8616が定める定格暖房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「定格暖房消費電力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格暖房能力」の合計値を機器全体の「定格暖房エネルギー消費効率」で除した値を" +
            "「定格暖房消費電力」として入力して下さい。ここで、機器全体の「定格暖房エネルギー消費効率」は、各々の機器において「定格暖房能力」を「定格暖房消費電力」で除して「定格暖房エネルギー消費効率」を算出し、" +
            "最も低い値とします。また、計算した「定格暖房消費電力」に小数点以下一位未満の端数が生じる場合は、小数点以下一位を切り上げて整数として下さい。</li></ul>",
    },
    hs_dc_rated_air_flow: {
        title: "定格暖房能力試験の値（風量）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による定格暖房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「定格暖房能力試験時の室内側送風機の風量」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格暖房能力試験時の室内側送風機の風量」の合計値を入力して下さい。</li></ul>",
    },
    hs_dc_rated_fan_power: {
        title: "定格暖房能力試験の値（室内側送風機の消費電力）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による定格暖房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「定格暖房能力試験時の室内側送風機の消費電力」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格暖房能力試験時の室内側送風機の消費電力」の合計値を入力して下さい。</li></ul>",
    },
    hs_dc_middle_capacity: {
        title: "中間暖房能力試験の値（能力）",
        text: "<ul><li>JIS B8616が定める中間暖房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「中間暖房能力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間暖房能力」の合計値を入力して下さい。</li></ul>",
    },
    hs_dc_middle_power: {
        title: "中間暖房能力試験の値（消費電力）",
        text: "<ul><li>JIS B8616が定める中間暖房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「中間暖房消費電力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間暖房能力」の合計値を機器全体の「中間暖房エネルギー消費効率」で除した値を「中間暖房消費電力」として" +
            "入力して下さい。ここで、機器全体の「中間暖房エネルギー消費効率」は、各々の機器において「中間暖房能力」を「中間暖房消費電力」で除して「中間暖房エネルギー消費効率」を算出し、最も低い値とします。" +
            "また、計算した「中間暖房消費電力」に小数点以下一位未満の端数が生じる場合は、小数点以下一位を切り上げて整数として下さい。</li></ul>",
    },
    hs_dc_middle_air_flow: {
        title: "中間暖房能力試験の値（風量）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による中間暖房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「中間暖房能力試験時の室内側送風機の風量」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間暖房能力試験時の室内側送風機の風量」の合計値を入力して下さい。</li></ul>",
    },
    hs_dc_middle_fan_power: {
        title: "中間暖房能力試験の値（室内側送風機の消費電力）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による中間暖房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「中間暖房能力試験時の室内側送風機の消費電力」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間暖房能力試験時の室内側送風機の消費電力」の合計値を入力して下さい。</li></ul>",
    },
    hs_dc_air_volume: {
        title: "設計風量",
        text: "<ul><li>定格暖房能力運転時の設計風量を入力して下さい。</li>" +
            "<li>算定方法については、「<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>2. エネルギー消費性能の算定方法</a>」の" +
            "「第五章 換気設備　付録B 換気設備の設計風量の計算方法」を参照して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「設計風量」の合計値を入力して下さい。</li></ul>",
    },
    cs_houhou: {
        title: "冷房方式",
        text: "<ul><li>冷房方式を「居室のみを冷房する」および「住戸全体を冷房する」に分類し、それぞれの方式に適用する冷房設備機器を設定します。" +
            "冷房設備機器を設置しない場合は「設置しない」を選択して下さい。</li>" +
            "<li>冷房設備機器を「設置しない」を選択した場合は、ルームエアコンディショナーが設置されたものとして評価します。</li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "冷房方式の運転方法等については「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第四章暖冷房設備」「第一節全般」の" +
                "「付録B 設置する冷房設備機器の種類に応じた冷房方式及び運転方法の決定方法並びに評価上想定される冷房設備機器の種類」を参照して下さい。",
        },
    },
    cs_type_1: {
        title: "住戸全体を冷房する／冷房設備機器の種類",
        text: "<ul><li>「住戸全体を冷房する」は、ヒートポンプを熱源とし、機外静圧を持った状態で運転されることを想定して、" +
            "ダクト等により住戸全体を空調するように計画された家庭用のダクト式セントラル空調（循環用送風機が室内機と一体となっているもの）で冷房する場合のみ選択することができます。" +
            "なお、クローゼットや納戸等の一部の空間を除いた非居室を含め、住宅全体を1以上のダクト式セントラル空調で冷房する場合も評価の対象となります。</li>" +
            "<li>ヒートポンプ式熱源でないダクト式セントラル空調機を評価する場合は、以下の手順で条件を入力して計算して下さい。" +
            "<ol><li>「冷房方式」で「居室のみを冷房する」を選択します。</li>" +
            "<li>「主たる居室」および「その他の居室」に、「冷房設備機器を設置しない」または「その他の冷房設備機器」を選択します。</li>" +
            "<li>「その他の冷房設備機器」を選択した場合は、「主たる居室」および「その他の居室」に同じ機器名称を入力します。</li></ol></li>" +
            "<li>複数のダクト式セントラル空調機を設置する場合は、以下の方法で能力や係数を求め、評価して下さい。" +
            "<ol style='list-style-type:upper-alpha;'><li>「定格冷房能力」は、設置する複数の機器の定格冷房能力を合計した値として下さい。</li>" +
            "<li>「定格冷房消費電力」は、1.で合計した定格冷房能力を設置する機器のうち<span style='text-decoration:underline'>最も低い</span>定格冷房エネルギー消費効率で除した値として下さい。</li>" +
            "<li>「冷房時におけるダクト等圧力損失による消費電力量補正係数」は、設置する複数の機器の冷房時における" +
            "ダクト等圧力損失による消費電力量補正係数のうち、最も大きい値として下さい。</li></ol></li></ul>",
    },
    cs_type_2: {
        title: "居室のみを冷房する／冷房設備機器の種類",
        text: "<ul><li>「居室のみを冷房する」を選択した場合は、「主たる居室」と「その他の居室」ごとに、設置する冷房設備機器等を選択します。" +
            "冷房設備機器等を設置しない場合は、「冷房設備機器を設置しない」を選択して下さい。</li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "設備機器等を設置しない場合、あるいは複数の設備機器等を設置する場合の運転方法の決定方法については、" +
                "「<a href='http://www.kenken.go.jp/becc/house.html' target='_blank'>設計一次エネルギー消費量算定方法</a>」の" +
                "「4　暖冷房設備　付録B 設置する冷房設備機器の種類に応じた冷房方式及び運転方法の決定方法並びに評価上想定される冷房設備機器の種類」を参照して下さい。",
        },
    },
    cs_ldk_type: {
        title: "居室のみを冷房する／冷房設備機器の種類",
        text: "<ul><li>「居室のみを冷房する」を選択した場合は、「主たる居室」と「その他の居室」ごとに、設置する冷房設備機器等を選択します。" +
            "冷房設備機器等を設置しない場合は、「冷房設備機器を設置しない」を選択して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "設備機器等を設置しない場合、あるいは複数の設備機器等を設置する場合の運転方法の決定方法については、" +
                "<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>「2.エネルギー消費性能の算定方法」</a>" +
                "の「第四章暖冷房設備」「第一節全般」の「付録B 設置する冷房設備機器の種類に応じた冷房方式及び運転方法の決定方法並びに評価上想定される冷房設備機器の種類」を参照して下さい。",
        },
    },
    cs_ldk_type1_houhou: {
        title: "エネルギー消費効率の入力（ルームエアコンディショナー）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。" +
            "ルームエアコンディショナーを居住者が設置予定などで、設置される機器が特定されない場合もこちらを選択して下さい。</li>" +
            "<li>「入力する」は、エネルギー消費効率の区分によって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    cs_ldk_aircon_koukouritsu: {
        title: "エネルギー消費効率の区分（ルームエアコンディショナー）",
        text: "<ul><li>エネルギー消費効率の区分とは、冷房定格能力の大きさごとに定格冷房エネルギー消費効率の程度に応じて三段階に区分したものです。</li></ul>",
        reference: {
            title: "平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "エネルギー消費効率の区分の確認方法は、「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第四章暖冷房設備」" +
                "「第三節ルームエアコンディショナー」の「付録A 機器の性能を表す仕様の決定方法」を参照して下さい。",
        },
    },
    cs_ldk_aircon_dualcompressor: {
        title: "小能力時高効率型コンプレッサー（ルームエアコンディショナー）",
        text: "<ul><li>小能力時高効率型コンプレッサーとは、概ね中間能力（定格能力の1/2）以下の小能力で運転する時、コンプレッサーのシリンダ容積を小さくする容量可変機構、" +
            "あるいは冷媒の漏れを防ぐシリンダの機構を有し、高効率かつ連続運転を可能にしたコンプレッサーのことです。</li>" +
            "<li>小能力時高効率型コンプレッサーの搭載については、カタログやメーカーWEBサイト等でご確認下さい。</li>" +
            "<li>複数のルームエアコンディショナーが設置される場合で、小能力時高効率型コンプレッサーの搭載の有無が異なる場合は、「搭載しない」を選択して下さい。</li></ul>",
        reference: {
            title: "平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "小能力時高効率型コンプレッサー搭載ルームエアコンディショナーの定義や判別方法については、" +
                "「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第四章暖冷房設備」「第三節ルームエアコンディショナー」の" +
                "「付録B 小能力時高効率型コンプレッサー搭載ルームエアコンディショナーの定義と判別方法」を参照して下さい。",
        },
    },
    cs_nldk_type: {
        title: "居室のみを冷房する／冷房設備機器の種類",
        text: "<ul><li>「居室のみを冷房する」を選択した場合は、「主たる居室」と「その他の居室」ごとに、設置する冷房設備機器等を選択します。冷房設備機器等を設置しない場合は、" +
            "「冷房設備機器を設置しない」を選択して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "設備機器等を設置しない場合、あるいは複数の設備機器等を設置する場合の運転方法の決定方法については、" +
                "<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>「2.エネルギー消費性能の算定方法」</a>" +
                "の「第四章暖冷房設備」「第一節全般」の「付録B 設置する冷房設備機器の種類に応じた冷房方式及び運転方法の決定方法並びに評価上想定される冷房設備機器の種類」を参照して下さい。",
        },
    },
    cs_nldk_type1_houhou: {
        title: "エネルギー消費効率の入力（ルームエアコンディショナー）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、省エネルギー対策に取り組んでいない場合、あるいは特に省エネルギー対策を評価しない場合に選択して下さい。" +
            "ルームエアコンディショナーを居住者が設置予定などで、設置される機器が特定されない場合もこちらを選択して下さい。</li>" +
            "<li>「入力する」は、エネルギー消費効率の区分によって省エネルギー効果を評価する場合に選択して下さい。</li></ul>",
    },
    cs_nldk_aircon_koukouritsu: {
        title: "エネルギー消費効率の区分（ルームエアコンディショナー）",
        text: "<ul><li>エネルギー消費効率の区分とは、冷房定格能力の大きさごとに定格冷房エネルギー消費効率の程度に応じて三段階に区分したものです。</li></ul>",
        reference: {
            title: "平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "エネルギー消費効率の区分の確認方法は、「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第四章暖冷房設備」" +
                "「第三節ルームエアコンディショナー」の「付録A 機器の性能を表す仕様の決定方法」を参照して下さい。",
        },
    },
    cs_nldk_aircon_dualcompressor: {
        title: "小能力時高効率型コンプレッサー（ルームエアコンディショナー）",
        text: "<ul><li>小能力時高効率型コンプレッサーとは、概ね中間能力（定格能力の1/2）以下の小能力で運転する時、コンプレッサーのシリンダ容積を小さくする容量可変機構、" +
            "あるいは冷媒の漏れを防ぐシリンダの機構を有し、高効率かつ連続運転を可能にしたコンプレッサーのことです。</li>" +
            "<li>小能力時高効率型コンプレッサーの搭載については、カタログやメーカーWEBサイト等でご確認下さい。</li>" +
            "<li>複数のルームエアコンディショナーが設置される場合で、小能力時高効率型コンプレッサーの搭載の有無が異なる場合は、「搭載しない」を選択して下さい。</li></ul>",
        reference: {
            title: "平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "小能力時高効率型コンプレッサー搭載ルームエアコンディショナーの定義や判別方法については、" +
                "「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第四章暖冷房設備」「第三節ルームエアコンディショナー」の" +
                "「付録B 小能力時高効率型コンプレッサー搭載ルームエアコンディショナーの定義と判別方法」を参照して下さい。",
        },
    },
    cs_type: {
        title: "住戸全体を冷房する／冷房設備機器の種類",
        text: "<ul><li>「住戸全体を冷房する」は、ヒートポンプを熱源とし、機外静圧を持った状態で運転されることを想定して、ダクト等により住戸全体を空調するように計画された家庭用のダクト式セントラル空調" +
            "（循環用送風機が室内機と一体となっているもの）で冷房する場合のみ選択することができます。なお、クローゼットや納戸等の一部の空間を除いた非居室を含め、" +
            "住宅全体を1以上のダクト式セントラル空調で冷房する場合も評価の対象となります。</li>" +
            "<li>ヒートポンプ式熱源でないダクト式セントラル空調機を評価する場合は、以下の手順で条件を入力して計算して下さい。" +
            "<ol><li>「冷房方式」で「居室のみを冷房する」を選択して下さい。</li>" +
            "<li>「主たる居室」および「その他の居室」に、「冷房設備機器または放熱器を設置しない」または「その他の冷房設備機器」を選択して下さい。</li>" +
            "<li>「その他の冷房設備機器」を選択した場合は、「主たる居室」および「その他の居室」に同じ機器名称を入力して下さい。</li></ol></li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、以下の方法で能力や係数を求め、評価してください。" +
            "<ol><li>「ダクトが通過する空間」は、すべての機器において「全て断熱区画内である」場合は「全て断熱区画内である」を選択して下さい。" +
            "それ以外の場合は、「評価しない、または全てもしくは一部が断熱区画外である」を選択して下さい。</li>" +
            "<li>「VAV方式」は、すべての機器において「採用する」の場合は「採用する」を選択して下さい。それ以外の場合は「評価しない、または採用しない」を選択して下さい。</li>" +
            "<li>「全般換気機能」は、すべての機器において「評価しない、または全般換気機能なし」の場合は「評価しない、または全般換気機能なし」を選択して下さい。それ以外の場合は「全般換気機能あり」を選択して下さい。</li>" +
            "<li>「機器の仕様の入力」は、次の通り選択して下さい。なお、定格能力試験および中間能力試験の「能力」、「消費電力」、「風量」及び「室内側送風機の消費電力」の求め方については、" +
            "それぞれの項目のヘルプを確認して下さい。" +
            "<ol><li>すべての機器が「定格能力試験と中間能力試験の値を入力する」に該当する場合、は「定格能力試験と中間能力試験の値を入力する」を選択して下さい。</li>" +
            "<li>上記の1に該当しない場合で、すべての機器が「定格能力試験の値を入力する」に該当する場合は「定格能力試験の値を入力する」を選択して下さい。</li>" +
            "<li>上記1にも2にもあてはまらない場合は、「入力しない」を選択して下さい。</li></ol></li>" +
            "<li>「設計風量の入力」は、「入力する／入力する」のいずれも選択できます。「設計風量」の値の求め方については、設計風量のヘルプを確認して下さい。</li></ol></li></ul>",
    },
    cs_dc_duct_dannnetu: {
        title: "ダクトが通過する空間",
        text: "<ul><li>ダクトが通過する空間が熱的境界に囲まれた空間である場合は「断熱区画内」、そうでない場合は「断熱区画外」を選択してください。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器において「全て断熱区画内である」場合は「全て断熱区画内である」を選択して下さい。" +
            "それ以外の場合は、「評価しない、または全てもしくは一部が断熱区画外である」を選択して下さい。</li></ul>",
    },
    cs_dc_vav: {
        title: "VAV方式",
        text: "<ul><li>空調機から居室までのダクト経路上に、ダンパ又はファンを配置して、居室の暖冷房負荷に応じて自動制御により送風量を増減する方式です。</li>" +
            "<li>以下の２つの要件を満たす場合は、「採用する」を選択して下さい。それ以外の場合は、「評価しない、または採用しない」を選択して下さい。<br>" +
            "次の制御・機能を有する機器であり、すべての居室ごとに、その居室で発生する冷暖房負荷に合わせて、風量を調整できること。" +
            "<ul><li>すべての居室ごとに、ダクト経路の端末もしくは途中にダンパーやファンを設置して、居室ごとに発生する冷暖房負荷に応じて、吹出風量を制御できること。</li>" +
            "<li>すべての居室に温度センサーが設置され、設定温度とセンサー検知温度の差に応じた制御を行うなど、自動で吹出風量を制御することができること。</li>" +
            "<li>全般換気（24時間換気）の機能を有する機器の場合は、温度調節が達成しても完全にダンパーが閉鎖もしくはファンが停止せず、全般換気（24時間換気）用の吹出風量を確保できる機能を有すること。</li></ul>" +
            "内機に次の機能がある機器であり、すべての居室ごとに風量を調整できるとともに、それに合わせて室内機の循環風量（全体風量）を調整できること。" +
            "<ul><li>各居室の風量もしくは室温は、システム制御にフィードバックされ、室内機本体でもインバーターやノッチで全体風量が調整でき、各居室で必要とされる風量の合計に調節できること。</li></ul></li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器において「採用する」の場合は「採用する」を選択して下さい。それ以外の場合は「評価しない、または採用しない」を選択して下さい。</li></ul>",
    },
    cs_dc_general_ventilation: {
        title: "全般換気機能",
        text: "<ul><li>全般換気機能とは、給気もしくは還気経路において新鮮外気を導入し、室内空気汚染物質の排出を目的として住宅全体または居室を対象として換気を行う機能です。</li>" +
            "<li>給気および還気経路において新鮮外気を導入していない場合は、「評価しない、または全般換気機能なし」を選択して下さい。それ以外の場合は、「全般換気機能あり」を選択して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器において「評価しない、または全般換気機能なし」の場合は「評価しない、または全般換気機能なし」を選択して下さい。" +
            "それ以外の場合は「全般換気機能あり」を選択して下さい。</li></ul>",
    },
    cs_dc_input: {
        title: "機器の仕様の入力",
        text: "<ul><li>「定格冷房能力試験の値」とは、JIS B8616が定める定格冷房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる能力および消費電力、ならびに、" +
            "室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による定格冷房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した室内側送風機の風量および消費電力です。</li>" +
            "<li>「中間冷房能力試験の値」とは、JIS B8616が定める中間冷房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる能力および消費電力、ならびに、" +
            "室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による中間冷房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した室内側送風機の風量および消費電力です。</li>" +
            "<li>但し、室内側送風機の風量および消費電力については、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、次の通り選択して下さい。" +
            "<ol><li>すべての機器が「定格能力試験と中間能力試験の値を入力する」に該当する場合、は「定格能力試験と中間能力試験の値を入力する」を選択して下さい。</li>" +
            "<li>上記の1.に該当しない場合で、すべての機器が「定格能力試験の値を入力する」に該当する場合は「定格能力試験の値を入力する」を選択して下さい。</li>" +
            "<li>上記1.にも2.にもあてはまらない場合は、「入力しない（規定値を用いる）」を選択して下さい。</li></ol></li></ul>",
    },
    cs_dc_rated_capacity: {
        title: "定格冷房能力試験の値（能力）",
        text: "<ul><li>JIS B8616が定める定格冷房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「定格冷房能力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格冷房能力」の合計値を入力して下さい。</li></ul>",
    },
    cs_dc_rated_power: {
        title: "定格冷房能力試験の値（消費電力）",
        text: "<ul><li>JIS B8616が定める定格冷房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「定格冷房消費電力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格冷房能力」の合計値を機器全体の「定格冷房エネルギー消費効率」で除した値を" +
            "「定格冷房消費電力」として入力して下さい。ここで、機器全体の「定格冷房エネルギー消費効率」は、各々の機器において「定格冷房能力」を「定格冷房消費電力」で除して「定格冷房エネルギー消費効率」を算出し、" +
            "最も低い値とします。また、計算した「定格冷房消費電力」に小数点以下一位未満の端数が生じる場合は、小数点以下一位を切り上げて整数として下さい。</li></ul>",
    },
    cs_dc_rated_air_flow: {
        title: "定格冷房能力試験の値（風量）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による定格冷房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「定格冷房能力試験時の室内側送風機の風量」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格冷房能力試験時の室内側送風機の風量」の合計値を入力して下さい。</li></ul>",
    },
    cs_dc_rated_fan_power: {
        title: "定格冷房能力試験の値（室内側送風機の消費電力）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による定格冷房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「定格冷房能力試験時の室内側送風機の消費電力」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「定格冷房能力試験時の室内側送風機の消費電力」の合計値を入力して下さい。</li></ul>",
    },
    cs_dc_middle_capacity: {
        title: "中間冷房能力試験の値（能力）",
        text: "<ul><li>JIS B8616が定める中間冷房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「中間冷房能力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間冷房能力」の合計値を入力して下さい。</li></ul>",
    },
    cs_dc_middle_power: {
        title: "中間冷房能力試験の値（消費電力）",
        text: "<ul><li>JIS B8616が定める中間冷房標準能力の定義に基づき、JIS B 8615-2が定める性能試験により得られる「中間冷房消費電力」を入力して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間冷房能力」の合計値を機器全体の「中間冷房エネルギー消費効率」で除した値を" +
            "「中間冷房消費電力」として入力して下さい。ここで、機器全体の「中間冷房エネルギー消費効率」は、各々の機器において「中間冷房能力」を「中間冷房消費電力」で除して「中間冷房エネルギー消費効率」を算出し、" +
            "最も低い値とします。また、計算した「中間冷房消費電力」に小数点以下一位未満の端数が生じる場合は、小数点以下一位を切り上げて整数として下さい。</li></ul>",
    },
    cs_dc_middle_air_flow: {
        title: "中間冷房能力試験の値（風量）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による中間冷房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「中間冷房能力試験時の室内側送風機の風量」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間冷房能力試験時の室内側送風機の風量」の合計値を入力して下さい。</li></ul>",
    },
    cs_dc_middle_fan_power: {
        title: "中間冷房能力試験の値（室内側送風機の消費電力）",
        text: "<ul><li>室内側及び室外側の送風機の風量をJIS B8615-2が定める空調機の性能試験による中間冷房能力の測定時と同一の風量に固定し、かつ、圧縮機が停止した状態で測定した" +
            "「中間冷房能力試験時の室内側送風機の消費電力」を入力して下さい。但し、測定時の凝縮器の表面状態（凝縮水）は不問とします。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「中間冷房能力試験時の室内側送風機の消費電力」の合計値を入力して下さい。</li></ul>",
    },
    cs_dc_air_volume: {
        title: "設計風量",
        text: "<ul><li>定格冷房能力運転時の設計風量を入力して下さい。</li>" +
            "<li>算定方法については、「<a href='https://www.kenken.go.jp/becc/house.html' target='_blank'>2. エネルギー消費性能の算定方法</a>」の" +
            "「第五章 換気設備　付録B 換気設備の設計風量の計算方法」を参照して下さい。</li>" +
            "<li>複数のヒートポンプ式熱源によるダクト式セントラル空調機を設置する場合は、すべての機器の「設計風量」の合計値を入力して下さい。</li></ul>",
    },
    vn_houshiki: {
        title: "換気設備の方式",
        text: "<ul><li>24時間換気に用いる換気設備を対象とします。</li>" +
            "<li>換気設備の種類（第一種、第二種、第三種換気設備のいずれか、またダクト式か壁付け式か）を選択して下さい。" +
            "なお、局所的に換気を行う設備（例えば、台所、浴室、便所等が対象）のエネルギー性能については評価しません。</li>" +
            "<li>「第一種換気」とは、給気及び排気を換気設備で行う方式をいいます。</li>" +
            "<li>「第二種換気」とは、給気を換気設備で行い、排気は自然排気で行う方式をいいます。</li>" +
            "<li>「第三種換気」とは、給気を自然給気で行い、排気は換気設備で行う方式をいいます。</li>" +
            "<li>「ダクト式」とは、換気設備に長さ１ｍ以上のダクトを接続するものをいいます。</li>" +
            "<li>「壁付け式」とは、換気設備に長さ１ｍ以上のダクトを接続しないものをいいます。</li>" +
            "<li>局所換気設備が全般換気設備を兼ねる場合は、該当する設備の方式を選択して下さい。</li><img src='/img/app/ventilation001.jpg'></ul>",
    },
    vn_duct_houhou: {
        title: "比消費電力の入力（ダクト式換気設備）",
        text: "<ul><li>「入力しない（省エネルギー手法を評価しない、または採用しない）」は、換気設備について特に省エネルギー対策を実施していない場合、あるいは省エネルギー対策を評価しない場合に選択して下さい。" +
            "設置される機器の省エネルギー対策が不明な場合もこちらを選択して下さい。</li>" +
            "<li>「入力しない（省エネルギー手法を採用する）」は、換気設備の省エネルギー対策として、「径の太いダクトを使用」あるいは、「径の太いダクトを使用、かつ直流モーターを採用」のいずれかの措置について" +
            "省エネルギー効果を評価する場合に選択して下さい。</li>" +
            "<li>「入力する」は、換気設備の省エネルギー対策の効果を比消費電力（設計風量当たりの換気設備の消費電力）に基づいて評価する場合に選択して下さい。</li></ul>",
    },
    vn_duct_houhou_2: {
        title: "省エネルギー手法を選択する（ダクト式換気設備）",
        text: "<ul><li>ダクト式換気設備の省エネルギー対策として、内径の太いダクトを使用した場合と、直流モーターの電動機を採用した場合について、省エネルギー効果を評価することができます。" +
            "省エネルギー手法の判断方法は下表のとおりです。" +
            "<table><tr><th>対策の選択肢</th><th>条件</th></tr>" +
            "<tr><td>径の太いダクトを使用する。</td><td>内径 75mm 以上のダクトのみを使用している場合</td></tr>" +
            "<tr><td>径の太いダクトを使用し、かつ DC モーターを採用する。</td><td>内径 75mm 以上のダクトのみを使用し、かつ電動機がすべて直流モーターの場合。</td></tr></table></li></ul>",
    },
    vn_duct_houhou_3: {
        title: "比消費電力を入力する（ダクト式換気設備）",
        text: "<ul><li>換気設備の省エネルギー対策として、「省エネルギー手法を選択する」の項目に示される対策以外の手法に取り組む場合などで、省エネルギー効果を反映させることができます。</li>" +
            "<li>比消費電力は、全般換気設備、ダクト及び電動機の種別に応じて定まる下表の数値を用いるか、または当該住戸において全般換気設備の消費電力及び全般換気設備の設計風量を求めて算出することができます。" +
            "なお、異なる種別に該当する換気設備を複数用いる場合は、各々の比消費電力を比較して最も大きな値を使用することとします。" +
            "<table><tr><th>全般換気設備の種類</th><th>基本となる比消費電力</th></tr>" +
            "<tr><td>ダクト式第一種換気設備（熱交換型換気設備）</td><td>0.7</td></tr>" +
            "<tr><td>ダクト式第一種換気設備</td><td>0.5</td></tr>" +
            "<tr><td>ダクト式第二種またはダクト式第三種換気設備</td><td>0.4</td></tr></table>" +
            "</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "比消費電力の計算方法等については「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第五章換気設備」を参照して下さい。",
        },
    },
    vn_duct_method: {
        title: "省エネルギー手法（ダクト式換気設備）",
        text: "<ul><li>ダクト式換気設備の省エネルギー対策として、内径の太いダクトを使用した場合と、直流モーターの電動機を採用した場合について、省エネルギー効果を評価することができます。" +
            "省エネルギー手法の判断方法は下表のとおりです。" +
            "<table><tr><th>対策の選択肢</th><th>条件</th></tr>" +
            "<tr><td>径の太いダクトを使用する。</td><td>内径 75mm 以上のダクトのみを使用している場合</td></tr>" +
            "<tr><td>径の太いダクトを使用し、かつ DC モーターを採用する。</td><td>内径 75mm 以上のダクトのみを使用し、かつ電動機がすべて直流モーターの場合。</td></tr></table></li></ul>",
    },
    vn_other_houhou: {
        title: "比消費電力の入力（壁付け式換気設備）",
        text: "<ul><li>「入力しない（規定値を用いる）」は、換気設備について特に省エネルギー対策を実施していない場合、あるいは省エネルギー対策を評価しない場合に選択して下さい。" +
            "設置される機器の省エネルギー対策が不明な場合もこちらを選択して下さい。</li>" +
            "<li>「入力する」は、換気設備の省エネルギー対策の効果を比消費電力（設計風量当たりの換気設備の消費電力）に基づいて評価する場合に選択して下さい。</li></ul>",
    },
    vn_other_houhou_2: {
        title: "比消費電力を入力する（壁付け式換気設備）",
        text: "<ul><li>比消費電力は、全般換気設備、ダクト及び電動機の種別に応じて定まる下表の数値を用いるか、または当該住戸において全般換気設備の消費電力及び全般換気設備の設計風量を求めて算出することができます。" +
            "なお、異なる種別に該当する換気設備を複数用いる場合は、各々の比消費電力を比較して最も大きな値を使用することとします。" +
            "<table><tr><th>全般換気設備の種類</th><th>比消費電力</th></tr>" +
            "<tr><td>壁付け式第一種換気設備（熱交換型換気設備）</td><td>0.7</td></tr>" +
            "<tr><td>壁付け式第一種換気設備</td><td>0.4</td></tr>" +
            "<tr><td>壁付け式第二種換気設備</td><td>0.3</td></tr>" +
            "<tr><td>壁付け式第三種換気設備</td><td>0.3</td></tr></table></li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "比消費電力の計算方法等については「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第五章換気設備」を参照して下さい。",
        },
    },
    vn_freq: {
        title: "換気回数",
        text: "<ul><li>評価対象住戸における換気回数を選択して下さい。" +
            "換気回数は、建築基準法施行令第 20 条の 7 第 1 項第 2号の表における「住宅等の居室」の分類等に従い判断して下さい。（下表）。</li></ul>" +
            "<table><tr><th>換気回数の選択肢</th><th>条件</th></tr>" +
            "<tr><td>0.5 回</td><td>建築基準法施行令第 20 条の 7 第 1 項第 2 号の表における「その他の居室」のみからなる住宅の場合に選択。</td></tr>" +
            "<tr><td>0.7 回</td><td>建築基準法施行令第 20 条の 7 第 1 項第 2 号の表において住宅等の居室において「換気回数が 0.7 以上の機械換気設備を設け、" +
            "又はこれに相当する換気が確保されるものとして、国土交通大臣が定めた構造を用い、若しくは国土交通大臣の認定を受けた居室」を含む住宅の場合に選択。</td></tr>" +
            "<tr><td>0.0 回</td><td>建築基準法施行令第 20 条の 8 第 2 項に適合し、建築基準法施行令第 20 条の 8 第 1 項に規定された機械換気設備の設置が不要となる居室」を含む住宅の場合に選択。</td></tr></table>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "換気回数の判断方法については、<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>「2.エネルギー消費性能の算定方法」</a>" +
                "の「第五章換気設備」を参照して下さい。"
        },
    },
    vn_e: {
        title: "第一種換気設備の有効換気量率",
        text: "<ul><li>有効換気量率とは、第一種換気設備において、有効換気量の給気量に対する比率のことです。第一種換気設備であって、還気が給気に混入することのない設備の場合は「1」を入力して下さい。</li>" +
            "<li>給気量は JIS B 8628（全熱交換器）における附属書１「風量測定方法」におけるチャンバ方式またはダクト方式により計測された値になります。</li>" +
            "<li>ダクト式第一種換気設備の有効換気量は、定格風量により以下の方法で求めてください。" +
            "<ol><li>小型全熱交換器（定格風量が 250m<sup>3</sup>/h 未満のもの）については JRA 4056「全熱交換器 有効換気量試験方法」におけるチャンバ内設置法</li>" +
            "<li>中型全熱交換器（定格風量が 250m<sup>3</sup>/h 以上 2000m<sup>3</sup>/h 以下のもの）については JRA 4056「全熱交換器 有効換気量試験方法」におけるダクト接続法</li></ol></li>" +
            "<li>壁付け式第一種換気設備の有効換気量は、JIS B 8628（全熱交換器）の附属書 3「有効換気量測定方法」における減衰法により測定及び計算される値を用いて求めます。</li></ul>",
        reference: {
            title: "平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "有効換気量率の計算方法は、<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>「2.エネルギー消費性能の算定方法」</a>の「第五章換気設備」を参照して下さい。"
        },
    },
    hw_setti: {
        title: "給湯設備・浴室等の有無",
        text: "「浴室等」とは、浴室、その他浴槽または身体の清浄を目的とした設備を有する室のことです。",
    },
    hw_shurui: {
        title: "熱源機の種類",
        text: "<ul><li>温水暖房用の温水供給を兼ねる場合は「給湯・温水暖房一体型」を、コージェネレーション設備を設置している場合は「コージェネレーションを使用する」を選択して下さい。" +
            "コージェネレーション設備の種類を選択する場合は、詳細版を利用して下さい。</li>" +
            "<li>評価時点で給湯機を設置しない場合は「給湯設備機器を設置しない」を、また選択肢にない給湯機を設置する場合は、「その他の給湯設備機器」を選択し、その名称も入力して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "給湯機を設置しない場合、あるいは複数の給湯機を設置する場合の決定方法については、" +
                "「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録A 複数の給湯機を設置する場合の評価において代表させる給湯機の決定方法 及び　付録B 給湯機を設置しない場合に評価において想定する機器の種類と仕様」を参照して下さい。",
        },
    },
    hw_shurui_senyo: {
        title: "熱源機(給湯専用型)の種類",
        text: "<ul><li>給湯専用の熱源機のみ選択できます。</li><li>給湯専用の熱源機以外" +
            "（給湯・温水暖房一体型、コージェネレーション設備、その他の給湯設備機器）を設置している場合は、「熱源機の分類」の項目を再選択して下さい。</li></ul>",
    },
    hw_senyo_sr1: {
        title: "ガス従来型給湯機",
        text: "<ul><li>ガス給湯機のうち、瞬間的に加熱して給湯する、JIS S2109 （家庭用ガス温水機器）における「先止め式の瞬間湯沸器」に該当する瞬間式のみを" +
            "評価対象とします（給湯時より前にあらかじめ加熱を行う貯湯式等は評価対象外です）。</li></ul>",
    },
    hw_senyo_sr7: {
        title: "ガス潜熱回収型給湯機",
        text: "<ul><li>ガス給湯機のうち、瞬間的に加熱して給湯する、JIS S2109 （家庭用ガス温水機器）における「先止め式の瞬間湯沸器」に該当する瞬間式のみを" +
            "評価対象とします（給湯時より前にあらかじめ加熱を行う貯湯式等は評価対象外です）。</li></ul>",
    },
    hw_senyo_sr2: {
        title: "石油従来型給湯機",
        text: "<ul><li>石油給湯機のうち、瞬間的に加熱して給湯する瞬間式（JIS S3024（石油小型給湯機）における瞬間形）及び" +
            "小型の貯湯槽を有する瞬間貯湯式（JIS S3024 における貯湯式急速加熱形）を評価対象とします（貯湯式は評価対象外です）。</li></ul>",
    },
    hw_senyo_sr8: {
        title: "石油潜熱回収型給湯機",
        text: "<ul><li>石油給湯機のうち、瞬間的に加熱して給湯する瞬間式（JIS S3024（石油小型給湯機）における瞬間形）及び" +
            "小型の貯湯槽を有する瞬間貯湯式（JIS S3024 における貯湯式急速加熱形）を評価対象とします（貯湯式は評価対象外です）。</li></ul>",
    },
    hw_senyo_sr3: {
        title: "電気ヒーター温水器",
        text: "<ul><li>JIS C9219（貯湯式電気温水器）に該当する機種のみを評価対象とします（瞬間式等は評価対象外です）。</li></ul>",
    },
    hw_senyo_sr4: {
        title: "電気ヒートポンプ給湯機(CO2冷媒)(太陽熱利用設備を使用しないもの)",
        text: "<ul><li>JIS C9220：2011（家庭用ヒートポンプ給湯機）又は一般社団法人日本冷凍空調工業会標準規格 JRA4050 （家庭用ヒートポンプ給湯機）に該当する機種を評価対象とします。</li>" +
            "<li>太陽熱利用給湯設備に接続して使用するものは、評価対象外です。</li></ul>",
    },
    hw_senyo_sr9: {
        title: "電気ヒートポンプ・ガス併用型給湯機",
        text: "<ul><li>電気ヒートポンプと潜熱回収型ガス熱源機により構成された給湯機です。ヒートポンプユニットや貯湯ユニットの品番、貯湯槽容量の大きさ、また暖房部と給湯部の構成によって分類されています。</li>" +
            "<li>各分類に該当する機器の型番は、一般社団法人住宅性能評価・表示協会の「温熱・省エネ設備機器等ポータル（住宅版）」にて公表されていますので" +
            "<a href='http://www2.hyoukakyoukai.or.jp/teitanso/info/hotwater_caty.php' target='_blank'>こちらのサイト</a>をご確認下さい。</li></ul>",
    },
    hw_ittai_sr1: {
        title: "ガス従来型給湯温水暖房機",
        text: "<ul><li>液化石油ガス（LPG）又は都市ガスを主たるエネルギー源とする給湯温水暖房機で、給湯機能と温水暖房機能を有するものです。</li>" +
            "<li>給湯機能において、瞬間式のみを評価対象とし、給湯時より前にあらかじめ加熱を行う貯湯式等は評価対象外です。</li>" +
            "<li>温水暖房機能においては、潜熱回収を行わない機器を評価対象とします。</li></ul>",
    },
    hw_ittai_sr2: {
        title: "ガス潜熱回収型給湯温水暖房機",
        text: "<ul><li>液化石油ガス（LPG）又は都市ガスを主たるエネルギー源とする給湯温水暖房機で、給湯機能と温水暖房機能を有するものです。</li>" +
            "<li>給湯機能において、瞬間式のみを評価対象とし、給湯時より前にあらかじめ加熱を行う貯湯式等は評価対象外です。</li>" +
            "<li>温水暖房機能においては、排気中の潜熱を回収して、熱効率を向上させた熱源機を評価対象とします。</li></ul>",
    },
    hw_ittai_sr3: {
        title: "石油従来型給湯温水暖房機",
        text: "<ul><li>灯油を主たるエネルギー源とする給湯温水暖房機で、給湯機能と温水暖房機能を有するものです。</li>" +
            "<li>給湯機能において、瞬間的に加熱して給湯する瞬間式及び小型の貯湯槽を有する瞬間貯湯式をさし、貯湯式は評価対象外です。</li>" +
            "<li>温水暖房機能においては、潜熱回収を行わない機器を評価対象とします。</li></ul>",
    },
    hw_ittai_sr4: {
        title: "石油潜熱回収型給湯温水暖房機",
        text: "<ul><li>灯油を主たるエネルギー源とする給湯温水暖房機で、給湯機能と温水暖房機能を有するものです。</li>" +
            "<li>給湯機能において、瞬間的に加熱して給湯する瞬間式及び小型の貯湯槽を有する瞬間貯湯式をさし、貯湯式は評価対象外です。</li>" +
            "<li>温水暖房機能においては、排気中の潜熱を回収して、熱効率を向上させた熱源機を評価対象とします。</li></ul>",
    },
    hw_ittai_sr5: {
        title: "電気ヒーター給湯温水暖房機",
        text: "<ul><li>電気ヒーターで温水を作る給湯温水暖房機で、通常、夜間時間帯の電気を利用して暖められた湯又は不凍液を貯湯タンクに貯める貯湯タイプが一般的です。</li>" +
            "<li>給湯機能において、瞬間式等は評価対象外です。</li></ul>",
    },
    hw_ittai_sr6_kosei: {
        title: "電気ヒートポンプ・ガス併用型給湯温水暖房機",
        text: "<ul><li>電気ヒートポンプと潜熱回収型ガス熱源機により構成された給湯機です。" +
            "ヒートポンプユニットや貯湯ユニットの品番、貯湯槽容量の大きさ、また暖房部と給湯部の構成によって分類されています。</li>" +
            "<li>各分類に該当する機器の型番は、一般社団法人住宅性能評価・表示協会の「温熱・省エネ設備機器等ポータル（住宅版）」にて公表されていますので" +
            "<a href='http://www2.hyoukakyoukai.or.jp/teitanso/info/hotwater_caty.php' target='_blank'>こちらのサイト</a>をご確認下さい。</li></ul>",
    },
    hw_src_type: {
        title: "ふろ機能の種類",
        text: "<ul><li>浴槽への湯はり機能及び沸かし直し機能の有無、または種類によって、給湯単機能、ふろ給湯機（追焚なし）及びふろ給湯機（追焚あり）の3種類に分類しています。</li>" +
            "<li>「給湯単機能」とは、水栓への給湯機能のみをもつ給湯機のことです。</li>" +
            "<li>「ふろ給湯機（追焚あり）」とは、水栓への給湯機能及び浴槽への自動湯はり機能をもつ給湯機のうち、追焚機能をもつ給湯機です。</li>" +
            "<li>「ふろ給湯機（追焚なし）」とは、水栓への給湯機能及び浴槽への自動湯はり機能をもつ給湯機のうち、追焚機能をもたない給湯機です。</li>" +
            "<li>給湯機が複数設置され、かつふろ機能の種類が同一でない場合は、1以上の給湯機が「ふろ給湯機（追焚あり）」であるときは「ふろ給湯機（追焚あり）」を選択、" +
            "これに該当しない場合で、1以上の給湯機が「ふろ給湯機（追焚なし）」であるときは、「ふろ給湯機（追焚なし）」を選択、これに該当しないときは、「給湯単機能」を選択して下さい。</li></ul>" +
            "<p>＜評価の優先順位＞<br>「ふろ給湯機（追焚あり）」＞「ふろ給湯機（追焚なし）」＞「給湯単機能」</p>",
    },
    hw_header_type: {
        title: "配管方式",
        text: "<ul><li>給湯熱源機から各給湯先までの配管方式は、ヘッダー方式（給湯熱源機から給湯ヘッダーを介し、各給湯先まで配管する場合）を採用し、ヘッダー分岐後(分岐後、部分的に先分岐となっている場合も含む)の" +
            "すべての配管径を小口径化（13A以下）することで、省エネルギー効果が認められます。</li></ul>",
    },
    hw_suisen: {
        title: "水栓",
        text: "<ul><li>台所、浴室、洗面に設置される水栓の種類をそれぞれ選択します。</li>" +
            "<li>湯の使用量低減によって一次エネルギー消費量の削減に資する水栓を「節湯水栓」といいます。</li>" +
            "<li>節湯水栓は、手元止水機構、小流量吐水機構、または水優先吐水機構を有するものを評価対象とします。なお、流量調節部及び温度調節部が使用者の操作範囲内にあるものを対象とします。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "節湯水栓の構造については、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 J 節湯水栓の構造」を参照して下さい。",
        },
    },
    hw_daidokoro_suisen: {
        title: "台所水栓",
        text: "<ul><li>台所水栓が複数ある場合は、以下の方法で水栓の仕様を選択してください。" +
            "<ol><li>１箇所でも「２バルブ水栓」があれば、「評価しない、または2バルブ水栓」を選択して下さい。</li>" +
            "<li>１箇所でも「手元止水機能」が付いていなければ、「無」を選択して下さい。</li>" +
            "<li>１箇所でも「水優先吐水機能」が付いていなければ、「無」を選択して下さい。</li></ol></li>" +
            "<li>「2バルブ水栓以外のその他の水栓」を選択した場合は、節湯水栓の機能（手元止水機能および水優先吐水機能）の採用の有無を選択して下さい。</li></ul>",
    },
    hw_daidokoro_temoto: {
        title: "手元止水機能",
        text: "<ul><li>台所に設置された湯水混合水栓で、吐水切替機能や流量及び温度の調節機能と独立し、使用者の操作範囲内に設けられたボタンやセンサー等のスイッチにより、" +
            "吐水及び止水操作ができる機構を有するものを評価対象とします。<br><img src='/img/app/hotwater003.jpg'></li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "節湯水栓の構造については、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 J 節湯水栓の構造」を参照して下さい。",
        },
    },
    hw_daidokoro_yusen: {
        title: "水優先吐水機能",
        text: "<ul><li>台所水栓のうち、以下の機構を有し、水栓又は取扱説明書等に水栓の正面位置が判断できる表示がされているものを評価対象とします。" +
            "<ol><li>吐水止水操作部と一体の温度調節を行うレバーハンドルが水栓の正面に位置するときに湯が吐出されない構造を有するもの</li>" +
            "<li>吐水止水操作部と一体の温度調節を行うレバーハンドルが水栓の胴の左右側面に位置する場合は、温度調節を行う回転軸が水平で、" +
            "かつレバーハンドルが水平から上方 45°に位置する時に湯が吐出されない構造を有するもの</li>" +
            "<li>湯水の吐水止水操作部と独立して水専用の吐水止水操作部が設けられた湯水混合水栓</li></ol>" +
            "<img src='/img/app/hotwater004.jpg'><br>" +
            "<img src='/img/app/hotwater005.jpg'><br>" +
            "<img src='/img/app/hotwater006.jpg'></li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "節湯水栓の構造については、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 J 節湯水栓の構造」を参照して下さい。",
        },
    },
    hw_shower_suisen: {
        title: "浴室シャワー水栓",
        text: "<ul><li>浴室シャワー水栓が複数ある場合は、以下の方法で水栓の仕様を選択してください。" +
            "<ol><li>１箇所でも「２バルブ水栓」があれば、「評価しない、または2バルブ水栓」を選択して下さい。</li>" +
            "<li>１箇所でも「手元止水機能」が付いていなければ、「無」を選択して下さい。</li>" +
            "<li>１箇所でも「小流量吐水機能」が付いていなければ、「無」を選択して下さい。</li></ol></li>" +
            "<li>「２バルブ水栓以外のその他の水栓」を選択した場合は、節湯水栓の機能（手元止水機能および小流量吐水機能）の採用の有無を選択して下さい。</li></ul>",
    },
    hw_shower_temoto: {
        title: "手元止水機能",
        text: "<ul><li>浴室シャワーに設置された湯水混合水栓で、吐水切替機能や流量及び温度の調節機能と独立し、使用者の操作範囲内に設けられたボタンやセンサー等のスイッチにより、" +
            "吐水及び止水操作ができる機構を有するものを評価対象とします。<br>" +
            "<img src='/img/app/hotwater008.jpg'></li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "節湯水栓の構造については、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 J 節湯水栓の構造」を参照して下さい。",
        },
    },
    hw_shower_shoryuryo: {
        title: "小流量吐水機能",
        text: "<ul><li>小流量吐水機構を有する水栓とは、「設計一次エネルギー消費量算定方法」の「7. 給湯設備　付録K 小流量吐水機構を有する水栓の適合条件」の方法によって試験を行ったときの吐水力が、" +
            "下表に適合する水栓をさします。</li>" +
            "<li>吐水切替えが可能な浴室シャワー水栓については、主たる使用モードにおいて条件を満たしていればよいです。なお、主たる使用モードとは、体を洗い流すことを目的とするモードで、" +
            "マッサージや温まり、掃除等を目的とする付加的なモードではありません。" +
            "<table><tr><th></th><th>適合の条件</th></tr>" +
            "<tr><td>流水中に空気を混入させる構造を持たないもの</td><td>0.60（単位 N）以上</td></tr>" +
            "<tr><td>流水中に空気を混入させる構造を持つもの</td><td>0.55（単位 N）以上</td></tr></table></li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "節湯水栓の構造については、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 J 節湯水栓の構造」を参照して下さい。",
        },
    },
    hw_senmen_suisen: {
        title: "洗面水栓",
        text: "<ul><li>洗面水栓が複数ある場合は、以下の方法で水栓の仕様を選択してください。" +
            "<ol><li>１箇所でも「２バルブ水栓」があれば、「評価しない、または2バルブ水栓」を選択して下さい。</li>" +
            "<li>１箇所でも「水優先吐水機能」が付いていなければ、「無」を選択して下さい。</li></ol></li>" +
            "<li>「２バルブ水栓以外のその他の水栓」を選択した場合には、節湯水栓 の機能（水優先吐水機能）の採用の有無を選択して下さい。</li></ul>",
    },
    hw_senmen_yusen: {
        title: "水優先吐水機能",
        text: "<ul><li>洗面水栓のうち、以下の機構を有し、水栓又は取扱説明書等に水栓の正面位置が判断できる表示がされているものを評価対象とします。" +
            "<ol><li>吐水止水操作部と一体の温度調節を行うレバーハンドルが水栓の正面に位置するときに湯が吐出されない構造を有するもの</li>" +
            "<li>吐水止水操作部と一体の温度調節を行うレバーハンドルが水栓の胴の左右側面に位置する場合は、温度調節を行う回転軸が水平で、かつレバーハンドルが水平から上方 45°に位置する時に" +
            "湯が吐出されない構造を有するもの</li>" +
            "<li>湯水の吐水止水操作部と独立して水専用の吐水止水操作部が設けられた湯水混合水栓</li></ol>" +
            "<img src='/img/app/hotwater009.jpg'></li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "節湯水栓の構造については、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 J 節湯水栓の構造」を参照して下さい。",
        },
    },
    hw_yokuso_hoon: {
        title: "浴槽の保温措置",
        text: "<ul><li>浴槽本体からの熱損失を軽減するために浴槽を保温構造とすることです。</li>" +
            "<li>JIS A 5532（浴槽）において「高断熱浴槽」と定義された浴槽の性能を満たしている場合に「高断熱浴槽を使用する」を選択することができます。</li></ul>",
    },
    hw_senyo_sr1_taisaku_2: {
        title: "効率(エネルギー消費効率)を入力する（ガス従来型給湯機）",
        text: "<ul><li>エネルギー消費効率とは、「エネルギーの使用の合理化に関する法律」に基づく「特定機器の性能の向上に関する製造事業者等の判断の基準等」（ガス温水機器）に定義される「エネルギー消費効率」のことです。" +
            "ただし、給湯温水暖房機でふろ機能の種類が「給湯単機能」あるいは「ふろ給湯機（追焚なし）」の場合は、JIS S 2109 による「（瞬間湯沸器の）熱効率」に基づき測定された値になります。</li>" +
            "<li>設置する給湯機が複数あり、いずれもガス給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "ガス熱源機のJIS効率に関する詳細は、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 C ガス給湯機及びガス給湯温水暖房機」を参照して下さい。",
        },
    },
    hw_senyo_sr1_taisaku_3: {
        title: "効率(モード熱効率)を入力する（ガス従来型給湯機）",
        text: "<ul><li>モード熱効率とは、JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に定められた測定方法に基づく値です。</li></ul>",
    },
    hw_senyo_sr2_taisaku_2: {
        title: "効率(エネルギー消費効率)を入力する（ガス潜熱回収型給湯機）",
        text: "<ul><li>エネルギー消費効率とは、「エネルギーの使用の合理化に関する法律」に基づく「特定機器の性能の向上に関する製造事業者等の判断の基準等」（ガス温水機器）に定義される「エネルギー消費効率」" +
            "のことです。ただし、給湯温水暖房機でふろ機能の種類が「給湯単機能」あるいは「ふろ給湯機（追焚なし）」の場合は、JIS S 2109 による「（瞬間湯沸器の）熱効率」に基づき測定された値になります。</li>" +
            "<li>設置する給湯機が複数あり、いずれもガス給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "ガス熱源機のJIS効率に関する詳細は、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 C ガス給湯機及びガス給湯温水暖房機」を参照して下さい。",
        },
    },
    hw_senyo_sr2_taisaku_3: {
        title: "効率(モード熱効率)効率(モード熱効率)を入力する（ガス潜熱回収型給湯機）",
        text: "<ul><li>モード熱効率とは、JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に定められた測定方法に基づく値です。</li></ul>",
    },
    hw_senyo_sr3_taisaku_2: {
        title: "効率(熱効率)を入力する（石油従来型給湯機）",
        text: "<ul><li>熱効率とは、JIS S 3031（石油燃焼機器の試験方法通則）の連続給湯効率試験方法あるいは湯沸効率試験方法に基づく「熱効率」の値です。</li>" +
            "<li>設置する給湯機が複数あり、いずれも石油給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "ガス熱源機のJIS効率に関する詳細は、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 D石油給湯機及び石油給湯温水暖房機」を参照して下さい。",
        },
    },
    hw_senyo_sr3_taisaku_3: {
        title: "効率(モード熱効率)を入力する（石油従来型給湯機）",
        text: "<ul><li>モード熱効率とは、評価対象機器の JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に基づくモード熱効率の値です。</li></ul>",
    },
    hw_senyo_sr4_taisaku_2: {
        title: "効率(熱効率)を入力する（石油潜熱回収型給湯機）",
        text: "<ul><li>熱効率とは、JIS S 3031（石油燃焼機器の試験方法通則）の連続給湯効率試験方法あるいは湯沸効率試験方法に基づく「熱効率」の値です。</li>" +
            "<li>設置する給湯機が複数あり、いずれも石油給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "ガス熱源機のJIS効率に関する詳細は、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 D石油給湯機及び石油給湯温水暖房機」を参照して下さい。",
        },
    },
    hw_senyo_sr4_taisaku_3: {
        title: "効率(モード熱効率)を入力する（石油潜熱回収型給湯機）",
        text: "<ul><li>モード熱効率とは、評価対象機器の JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に基づくモード熱効率の値です。</li></ul>",
    },
    hw_senyo_sr6_taisaku_2: {
        title: "JIS効率を入力する",
        text: "<ul><li>JIS 効率とは、評価対象機器の JIS C 9220：2011（家庭用ヒートポンプ給湯機） に基づく年間給湯保温効率（JIS）又は年間給湯効率（JIS）の値です。小数点以下1桁までの値を入力して下さい。" +
            "なお、JIS C 9220：2018に基づく「ふろ熱回収機能」を含むJIS効率では、現時点では評価できませんので、JIS C 9220：2011に基づくJIS効率を確認の上、入力してください。</li>" +
            "<li>設置する機種に、これらの値が表示されておらず、代わりに、日本冷凍空調工業会標準規格 JRA4050（家庭用ヒートポンプ給湯機）に基づく年間給湯効率（APF）が表示されている場合は、" +
            "以下の方法で効率を求めてください。" +
            "<ol><li>ふろ機能の種類が「給湯単機能」又は「ふろ給湯機（追焚なし）」の場合<br>JRA4050に基づく年間給湯効率（APF）の値を用いて下式より換算した値<br>" +
            "JIS 効率（プログラムへの入力値） ＝ 年間給湯効率（APF）－ 0.5</li>" +
            "<li>ふろ機能の種類が「ふろ給湯機（追焚あり）」の場合<br>JRA4050:2007R に基づく年間給湯効率（APF）の値を用いて下式より換算した値<br>" +
            "JIS 効率（プログラムへの入力値） ＝ 年間給湯効率（APF）－ 0.7</li></ol></li>" +
            "<li>設置する給湯機が複数あり、いずれも電気ヒートポンプ給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "ガス熱源機のJIS効率に関する詳細は、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第七章第一節給湯設備」の" +
                "「付録 E 電気ヒートポンプ給湯機」を参照して下さい。",
        },
    },
    hw_senyo_sr6_taisaku_3: {
        title: "M1スタンダードに基づくJIS相当効率を入力する（認定機種のみ）",
        text: "<ul><li>「<a href='http://www.kenken.go.jp/becc/house.html#2-2' target='_blank'>平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）</a>」の" +
            "2.2 算定方法「第七章 給湯設備」に添付する『電気ヒートポンプ給湯機（CO2冷媒）の M1 スタンダードに基づく JIS 相当効率について』に掲載されている機種に限ります。</li></ul>",
    },
    hw_senyo_sr7_package_input: {
        title: "電気ヒートポンプ・ガス併用型給湯機の指定",
        text: "<ul><li>該当する電気ヒートポンプ・ガス併用型給湯機を検索することができます。</li>" +
            "<li>電気ヒートポンプ・ガス併用型給湯機を販売する「ブランド事業者名」や、機器の「ヒートポンプユニット品番」、「貯湯ユニット品番」、「補助熱源機品番」あるいは" +
            "成績証明書番号または自己適合宣言書番号品番」の一部の文字やアルファベット記号、数字を入力すると対象となる機器が絞り込まれます。</li>" +
            "<li>入力する文字は半角英数字です。</li></ul>",
    },
    hw_senyo_sr7_coolant_type: {
        title: "冷媒の種類",
        text: "<ul><li>電気ヒートポンプ・ガス併用型給湯機に充填されている冷媒について、フロン系（R410A、R32）あるいはプロパン系のいずれかを選択してください。</li></ul>",
    },
    hw_senyo_sr7_tank: {
        title: "タンク容量",
        text: "<ul><li>タンク容量は貯湯槽容量により下表のように分類されます。貯湯槽容量をご確認の上、タンク容量を選択してください。" +
            "<table><tr><th>タンク容量</th><th>貯湯槽容量</th></tr>" +
            "<tr><td>タンク容量（小）	</td><td>貯湯槽容量  95L未満のもの</td></tr>" +
            "<tr><td>タンク容量（大）	</td><td>貯湯槽容量  95L以上のもの</td></tr></table></li></ul>",
    },
    hw_ittai_sr11_heater_e: {
        title: "暖房部 熱効率（ガス従来型給湯温水暖房機）",
        text: "<ul><li>暖房部熱効率とは、JIS S 2112（家庭用ガス温水熱源機）に定められた測定方法による「エネルギー消費効率（％）」（熱効率（％））の値です。</li></ul>",
    },
    hw_ittai_sr11_hotwater_e: {
        title: "給湯部 エネルギー消費効率（ガス従来型給湯温水暖房機）",
        text: "<ul><li>エネルギー消費効率とは、「エネルギーの使用の合理化に関する法律」に基づく「特定機器の性能の向上に関する製造事業者等の判断の基準等」（ガス温水機器）に定義される" +
            "「エネルギー消費効率」のことです。ただし、給湯温水暖房機でふろ機能の種類が「給湯単機能」あるいは「ふろ給湯機（追焚なし）」の場合は、JIS S 2109 による「（瞬間湯沸器の）熱効率」に基づき" +
            "測定された値になります。</li>" +
            "<li>設置する給湯機が複数あり、いずれもガス給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
    },
    hw_ittai_sr11_hotwater_emode: {
        title: "給湯部 モード熱効率（ガス従来型給湯温水暖房機）",
        text: "<ul><li>モード熱効率とは、JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に定められた測定方法に基づく値です。</li></ul>",
    },
    hw_ittai_sr12_heater_e: {
        title: "暖房部 熱効率（ガス潜熱回収型給湯温水暖房機）",
        text: "<ul><li>暖房部熱効率とは、JIS S 2112（家庭用ガス温水熱源機）に定められた測定方法による「エネルギー消費効率（％）」（熱効率（％））の値です。</li></ul>",
    },
    hw_ittai_sr12_hotwater_e: {
        title: "給湯部 エネルギー消費効率（ガス潜熱回収型給湯温水暖房機）",
        text: "<ul><li>エネルギー消費効率とは、「エネルギーの使用の合理化に関する法律」に基づく「特定機器の性能の向上に関する製造事業者等の判断の基準等」（ガス温水機器）に定義される" +
            "「エネルギー消費効率」のことです。ただし、給湯温水暖房機でふろ機能の種類が「給湯単機能」あるいは「ふろ給湯機（追焚なし）」の場合は、JIS S 2109 による「（瞬間湯沸器の）熱効率」に基づき" +
            "測定された値になります。</li>" +
            "<li>設置する給湯機が複数あり、いずれもガス給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
    },
    hw_ittai_sr12_hotwater_emode: {
        title: "給湯部 モード熱効率（ガス潜熱回収型給湯温水暖房機）",
        text: "<ul><li>モード熱効率とは、JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に定められた測定方法に基づく値です。</li></ul>",
    },
    hw_ittai_sr13_heater_e: {
        title: "暖房部 熱効率（石油従来型給湯温水暖房機）",
        text: "<ul><li>暖房部熱効率とは、JIS S 3031 （石油燃焼機器の試験方法通則）に定められた測定方法による「エネルギー消費効率（%）」（熱効率（%））の値です。</li></ul>",
    },
    hw_ittai_sr13_hotwater_e: {
        title: "給湯部 熱効率（石油従来型給湯温水暖房機）",
        text: "<ul><li>熱効率とは、JIS S 3031（石油燃焼機器の試験方法通則）の連続給湯効率試験方法あるいは湯沸効率試験方法に基づく「熱効率」の値です。</li>" +
            "<li>設置する給湯機が複数あり、いずれも石油給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
    },
    hw_ittai_sr13_hotwater_emode: {
        title: "給湯部 モード熱効率（石油従来型給湯温水暖房機）",
        text: "<ul><li>モード熱効率とは、JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に定められた測定方法に基づく値です。</li></ul>",
    },
    hw_ittai_sr14_hotwater_e: {
        title: "給湯部 熱効率（石油潜熱回収型給湯温水暖房機）",
        text: "<ul><li>熱効率とは、JIS S 3031（石油燃焼機器の試験方法通則）の連続給湯効率試験方法あるいは湯沸効率試験方法に基づく「熱効率」の値です。</li>" +
            "<li>設置する給湯機が複数あり、いずれも石油給湯機でかつ効率が異なる場合は、効率の小さい方の値を用いて評価して下さい。</li></ul>",
    },
    hw_ittai_sr14_hotwater_emode: {
        title: "給湯部 モード熱効率（石油潜熱回収型給湯温水暖房機）",
        text: "<ul><li>モード熱効率とは、JIS S 2075（家庭用ガス・石油温水機器のモード効率測定法）に定められた測定方法に基づく値です。</li></ul>",
    },
    hw_ittai_sr16_tank: {
        title: "タンクユニットの設置場所",
        text: "<ul><li>電気ヒートポンプ・ガス併用型給湯温水暖房機のうち、暖房部の熱源を電気ヒートポンプとガスで、給湯部の熱源をガスで構成している給湯温水暖房機については、" +
            "タンクユニットの屋内外設置状況を確認し、選択肢のいずれかを選択して下さい。</li></ul>",
    },
    hw_ittai_sr17_kubun: {
        title: "電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機の区分",
        text: "<ul><li>タンク容量により下表のように分類されます。当該設備のタンクユニット型番と製造事業者をご確認の上、区分を選択してください。" +
            "<table><tr><th>区分</th><th>タンク容量</th><th>タンクユニット型番と製造事業者</th></tr>" +
            "<tr><td rowspan='7'>区分１</td><td rowspan='7'>タンク容量  160L未満のもの</td><td>RTU-R1001 （リンナイ（株））</td></tr><tr><td>RTU-R1003 （リンナイ（株））</td></tr>" +
            "<tr><td>RTU-R1003K （リンナイ（株））</td></tr><tr><td>RTU-R1003（E) （リンナイ（株））</td></tr><tr><td>RTU-R1003（E)EG （リンナイ（株））</td></tr>" +
            "<tr><td>RTU-R1003K（E) （リンナイ（株））</td></tr><tr><td>RTU-R1003K（E)EG （リンナイ（株））</td></tr>" +
            "<tr><td rowspan='4'>区分２</td><td rowspan='4'>タンク容量  160L以上のもの</td><td>RTU-R1601 （リンナイ（株））</td></tr><tr><td>RTU-R1601-EG （リンナイ（株））</td></tr>" +
            "<tr><td>RTU-R1601K （リンナイ（株））</td></tr><tr><td>RTU-R1601K-EG （リンナイ（株））</td></tr>" +
            "</table></li></ul>",
    },
    hw_ittai_sr18_package_input: {
        title: "電気ヒートポンプ・ガス併用型給湯温水暖房機の指定",
        text: "<ul><li>該当する電気ヒートポンプ・ガス併用型給湯温水暖房機を検索することができます。</li>" +
            "<li>電気ヒートポンプ・ガス併用型給湯温水暖房機を販売する「ブランド事業者名」や、機器の「ヒートポンプユニット品番」、「貯湯ユニット品番」、「補助熱源機品番」あるいは" +
            "「成績証明書番号または自己適合宣言書番号品番」の一部の文字やアルファベット記号、数字を入力すると対象となる機器が絞り込まれます。</li>" +
            "<li>入力する文字は半角英数字です。</li></ul>",
    },
    hw_ittai_sr18_coolant_type: {
        title: "冷媒の種類",
        text: "<ul><li>電気ヒートポンプ・ガス併用型給湯温水暖房機に充填されている冷媒について、フロン系（R410A、R32）あるいはプロパン系のいずれかを選択してください。</li></ul>",
    },
    hw_ittai_sr18_tank: {
        title: "タンク容量",
        text: "<ul><li>タンク容量は貯湯槽容量により下表のように分類されます。貯湯槽容量をご確認の上、タンク容量を選択してください。" +
            "<table><tr><th>タンク容量</th><th>貯湯槽容量</th></tr>" +
            "<tr><td>タンク容量（小）</td><td>貯湯槽容量  95L未満のもの</td></tr>" +
            "<tr><td>タンク容量（大）</td><td>貯湯槽容量  95L以上のもの</td></tr></table></li></ul>",
    },
    ls_main_setti: {
        title: "設置の有無（主たる居室）",
        text: "<ul><li>居間（リビング）、食堂（ダイニング）、台所（キッチン）のいずれかに一か所にでも照明設備を設置する場合は、「設置する」を選択して下さい。</li></ul>",
    },
    ls_main_design: {
        title: "照明器具の種類（主たる居室）",
        text: "<ul><li>主たる居室に一か所でも照明設備を設置している場合は評価の対象となります。</li>" +
            "<li>「すべての機器においてLEDを使用している」は、主たる居室のすべての照明設備にLEDを使用している場合に選択して下さい。</li>" +
            "<li>「すべての機器において白熱灯以外を使用している」は、主たる居室のすべての照明設備に白熱灯以外" +
            "（すべての照明設備でLEDを使用している場合を除きます）を使用している場合に選択して下さい。</li>" +
            "<li>「いずれかの機器において白熱灯を使用している」は、主たる居室の照明設備のいずれかに白熱灯を使用している場合に選択して下さい。" +
            "白熱灯とは、一般照明用白熱電球、ミニクリプトン電球、ハロゲン電球等の種類を含みます。" +
            "なお、キッチンに設置するレンジフード内の手元灯については、白熱灯等以外の器具が設置されている製品が少ないため、当面の間は評価対象外とします。</li></ul>",
    },
    ls_main_multi: {
        title: "多灯分散照明方式",
        text: "<ul><li>多灯分散照明方式とは、主たる居室において、一室に複数の照明設備の消費電力の合計を制限して設置することで、運用時の消費電力量削減と光環境の向上を図る照明方式のことです。</li>" +
            "<li>多灯分散照明方式は、評価対象住戸の主たる居室に設置された照明設備の消費電力の合計が、拡散配光器具（居室等、広い範囲を照らすための配光を有する照明器具。シーリングライト等）により" +
            "必要な設計照度を得るための照明設備の消費電力の合計を超えないことを適用条件としています。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "多灯分散照明方式の適用条件については、「<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第六章照明設備」の" +
                "「6.7多灯分散照明方式による補正係数」を参照して下さい。",
        },
    },
    ls_main_dimming: {
        title: "調光が可能な制御",
        text: "<ul><li>照明設備の光束を段階的または無段階で調節できる機能を有する制御です。減光することによってエネルギー削減効果が得られます。</li>" +
            "<li>照明設備本体が有する調光機能による場合と、照明設備本体とは別の調光器による場合があります。2～3 本の蛍光灯がセットになった照明器具で、" +
            "スイッチにより点灯本数を調整する「段調光」も評価対象とします。</li></ul>",
    },
    ls_general_setti: {
        title: "設置の有無（その他の居室）",
        text: "<ul><li>寝室、子ども室、和室等、その他の居室が複数ある場合は、いずれかの居室に一か所でも設置する場合は、「設置する」を選択して下さい。" +
            "※クローゼット・納戸等に設置する器具は「非居室」で評価します。</li></ul>",
    },
    ls_general_device: {
        title: "照明器具の種類（その他の居室）",
        text: "<ul><li>その他の居室に一か所でも照明設備を設置している場合は評価の対象となります。</li>" +
            "<li>「すべての機器においてLEDを使用している」は、その他の居室のすべての照明設備にLEDを使用している場合に選択して下さい。</li>" +
            "<li>「すべての機器において白熱灯以外を使用している」は、その他の居室のすべての照明設備に白熱灯以外" +
            "（すべての照明設備でLEDを使用している場合を除きます）を使用している場合に選択して下さい。</li>" +
            "<li>「いずれかの機器において白熱灯を使用している」は、その他の居室の照明設備のいずれかに白熱灯を使用している場合に選択して下さい。" +
            "白熱灯とは、一般照明用白熱電球、ミニクリプトン電球、ハロゲン電球等の種類を含みます。" +
            "なお、キッチンに設置するレンジフード内の手元灯については、白熱灯等以外の器具が設置されている製品が少ないため、当面の間は評価対象外とします。</li></ul>",
    },
    ls_general_dimming: {
        title: "調光が可能な制御",
        text: "<ul><li>照明設備の光束を段階的または無段階で調節できる機能を有する制御です。減光することによってエネルギー削減効果が得られます。</li>" +
            "<li>照明設備本体が有する調光機能による場合と、照明設備本体とは別の調光器による場合があります。" +
            "2～3 本の蛍光灯がセットになった照明器具で、スイッチにより点灯本数を調整する「段調光」も評価対象とします。</li></ul>",
    },
    ls_other_setti: {
        title: "設置の有無（非居室）",
        text: "<ul><li>浴室・洗面所・トイレ・廊下・玄関・クローゼット・納戸等、非居室のうちいずれか一か所でも設置する場合は、「設置する」を選択して下さい。</li></ul>",
    },
    ls_other_device: {
        title: "照明器具の種類（非居室）",
        text: "<ul><li>非居室に一か所でも照明設備を設置している場合は評価の対象となります。</li>" +
            "<li>「すべての機器においてLEDを使用している」は、非居室のすべての照明設備にLEDを使用している場合に選択して下さい。</li>" +
            "<li>「すべての機器において白熱灯以外を使用している」は、非居室のすべての照明設備に白熱灯以外" +
            "（すべての照明設備でLEDを使用している場合を除きます）を使用している場合に選択して下さい。</li>" +
            "<li>「いずれかの機器において白熱灯を使用している」は、非居室の照明設備のいずれかに白熱灯を使用している場合に選択して下さい。" +
            "白熱灯とは、一般照明用白熱電球、ミニクリプトン電球、ハロゲン電球等の種類を含みます。" +
            "なお、キッチンに設置するレンジフード内の手元灯については、白熱灯等以外の器具が設置されている製品が少ないため、当面の間は評価対象外とします。</li></ul>",
    },
    ls_other_control: {
        title: "人感センサー",
        text: "<ul><li>人感センサーとは、人を感知して自動で照明設備を点滅させる機能です。" +
            "手動でスイッチをオン・オフさせる場合の消し忘れを防ぎ、また短時間の照明が必要な非居室等における区画においてエネルギー削減効果が得られます。</li></ul>",
    },
    hv_houshiki: {
        title: "熱交換型換気設備",
        text: "<ul><li>熱交換換気設備を採用することにより、条件によって暖房負荷を削減することができます。" +
            "評価対象住戸に、熱交換型換気設備を設置する場合に熱交換型換気を「設置する」を選択して下さい。</li>" +
            "<li>８地域では、熱交換型換気を「設置する」を選択することはできません。</li>" +
            "<li>熱交換型換気設備の「有効換気量率」、「温度交換効率」、計算対象とする住宅の「設計給気風量」及び「設計還気風量」又は" +
            "「設計外気風量」及び「設計排気風量」の情報が不明な場合は、熱交換型換気を「設置する」を選択することはできません。</li></ul>",
    },
    hv_eff: {
        title: "温度交換効率",
        text: "<ul><li>熱交換型換気設備において、給気乾球温度と外気乾球温度の差が還気乾球温度と外気乾球温度の差にどれだけ近いかを表す指標です。</li>" +
            "<li>JIS B 8628 （全熱交換器）に規定された温度交換効率を入力して下さい。顕熱交換型換気設備の場合も、JIS B 8628に規定された試験方法及び計算方法により計算で求めてください。</li>" +
            "<li>値は、100分の1未満の端数を切り下げた小数第二位までの値とし、パーセント単位で入力してください（値に100を乗じてください）。ただし、値が95（％）を上回る場合は、95を入力してください。</li>" +
            "<li>なお、以下の場合は熱交換型換気設備による暖房負荷の削減効果を見込むことはできません。" +
            "<ul><li>温度交換効率ηtが0.4を下回る場合</li>" +
            "<li>定格条件における給気風量が定格条件における排気風量の半分未満、若しくは2倍より大きい場合</li></ul></li></ul>",
    },
    hv_bal: {
        title: "給気と排気の比率による温度交換効率の補正係数",
        text: "<ul><li>給気と排気の比率による温度交換効率の補正係数Cbalは0.9とするか、もしくは、下式により求めた値を用いることができます。計算により求めた値を用いる場合は、" +
            "100分の1未満の端数を切り下げた小数第二位までの値としてください。<br>" +
            "<img src='/img/app/ventilation004.jpg'><br>ここで、<br>" +
            "η<sub>t,d</sub>：当該住戸における補正設計風量比での熱交換型換気設備の温度交換効率<br>" +
            "η<sub>t</sub>：熱交換型換気設備の温度交換効率<br>" +
            "η<sub>t,d</sub>の計算方法は、以下の参照資料に示されています。" +
            "なお、画面下部にある「温度交換効率の補正係数（C<sub>bal</sub>、C<sub>leak</sub>）の算出ツール」を用いてC<sub>bal</sub>を計算することができます。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "η<sub>t,d</sub>の計算方法は、「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の「第三章暖冷房負荷と外皮性能」「第一節全般」の" +
                "「付録A熱交換型換気設備」を参照して下さい。",
        },
    },
    hv_leak: {
        title: "排気過多時における住宅外皮経由の漏気による温度交換効率の補正係数",
        text: "<ul><li>排気過多時における住宅外皮経由の漏気による温度交換効率の補正係数Cleakは、設計給気風量Vd,in（m3/h）と設計還気風量Vd,out（m3/h）を用い、下式により求めた数値を入力します。" +
            "その際、設計給気風量及び設計還気風量のかわりに設計外気風量及び設計排気風量を用いることもできます。<br>" +
            "<img src='/img/app/ventilation003.jpg'></li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "設計給気風量、設計還気風量、設計外気風量及び設計排気風量は、「<a href='https://www.kenken.go.jp/becc/house.html#2' target='_blank'>2.エネルギー消費性能の算定方法</a>」の" +
                "「第五章換気設備」に規定された値としてください。",
        },
    },
    pv_saiyou: {
        title: "太陽光発電設備",
        text: "<ul><li>太陽光発電をする場合は、評価対象住戸が建設される地域の「年間日射地域区分」を確認して、該当する区分を選択して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "日射地域区分の詳細は、<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>" +
                "「2.エネルギー消費性能の算定方法」</a>の「第十一章第二節日射に関する地域の区分と日射量等」を参照して下さい。",
        },
    },
    pv_panelsuu: {
        title: "方位の異なるパネルの面数",
        text: "<ul><li>同じ方位に設置する場合でも、「太陽電池アレイ設置方式」や「パネルの設置傾斜角」等の仕様が異なる場合は、異なるパネルとして区別し入力して下さい。" +
            "入力に際しては、「太陽電池アレイのシステム容量」の大きいものから順に入力し、パネル面数が4 を超える場合は評価対象外とします。</li>" +
            "<li>なお、太陽電池アレイの方位角、傾斜角、半導体の種類として結晶系か結晶系以外かの別及び設置方式が同一の複数の太陽電池アレイについては、各太陽電池アレイのシステム容量を合計することで、" +
            "1 つの太陽電池アレイとみなしても構いません。</li></ul>",
    },
    pv_pcs_koritsu_e: {
        title: "パワーコンディショナの定格負荷効率",
        text: "<ul><li>JIS C 8961「太陽光発電用パワーコンディショナの効率測定方法」に基づき測定された定格負荷効率を入力してください。" +
            "詳しい入力方法については、<a href='https://www.kenken.go.jp/becc/documents/house/9-1_Rated_load_efficiency_of_PC_191001_v01_Pver0207.pdf' target='_blank'>こちら</a>をご確認下さい。</li>" +
            "<li>複数台のパワーコンディショナが設置される場合は、最も定格負荷効率（JIS C 8961に基づく値）の低いパワーコンディショナの値を入力してください。</li></ul>",
    },
    pv_panel_youryo: {
        title: "太陽電池アレイのシステム容量",
        text: "<ul><li>「太陽電池アレイのシステム容量」とは、標準試験条件の状態に換算した太陽電池アレイの最大出力点における出力です。太陽電池アレイ容量とも言われます。</li>" +
            "<li>太陽電池アレイのシステム容量は、JIS C8951（太陽電池アレイ通則）の測定方法に基づき測定され、" +
            "JIS C8952（太陽電池アレイの表示方法）に基づいて表示された「標準太陽電池アレイ出力」が確認出来る場合はその値を入力して下さい。</li>" +
            "<li>「標準太陽電池アレイ出力」が記載されていない場合は、製造業者の仕様書、技術資料等を参考に、" +
            "以下の JIS 等に基づいて記載された太陽電池モジュールの 1 枚当たりの標準太陽電池モジュール出力値を確認し、モジュール枚数分の合計値を入力して下さい。" +
            "<table><tr><th colspan='2'>太陽電池の種類</th><th>条件</th></tr>" +
            "<tr><td colspan='2'>結晶シリコン系太陽電池</td><td>JISC8918、JISC8990又はIEC61215</td></tr>" +
            "<tr><td colspan='2' style='border-bottom:none;'>結晶シリコン系以外の太陽電池</td><td>JISC8991又はIEC61646</td></tr>" +
            "<tr><td style='border-bottom:none; border-top:none;'></td><td>アモルファス太陽電池</td><td>JISC8939</td></tr>" +
            "<tr><td style='border-top:none;'></td><td>多接合太陽電池</td><td>JISC8943</td></tr></table></li>" +
            "<li>太陽電池アレイのシステム容量は、小数点第三位を四捨五入し、小数点第二位までの値を入力して下さい。</li>" +
            "<li>なお、太陽電池アレイの方位角、傾斜角、半導体の種類として結晶系か結晶系以外かの別及び設置方式が同一の複数の太陽電池アレイについては、各太陽電池アレイのシステム容量を合計することで、" +
            "1 つの太陽電池アレイとみなしても構いません。その場合は、各太陽電池アレイのシステム容量の合計値の小数点第三位を四捨五入し、小数点第二位までの値を用いて下さい。</li></ul>",
    },
    pv_panel_shurui: {
        title: "太陽電池アレイの種類",
        text: "<ul><li>太陽電池の種類を「結晶シリコン系太陽電池」と「結晶シリコン系以外の太陽電池」から選択して下さい。「結晶シリコン系以外の太陽電池」には、" +
            "単結晶シリコン及び多結晶シリコン以外のアモルファス太陽電池や多接合太陽電池が該当します。</li>" +
            "<li>結晶シリコン系太陽電池であるかどうかは、製造業者の仕様書又は技術資料などにより確認して下さい。</li></ul>",
    },
    pv_panel_setti: {
        title: "太陽電池アレイ設置方式",
        text: "<ul><li>「太陽電池アレイ設置方式」とは、太陽電池アレイの取り付け方を示し、本評価では「架台設置形」「屋根置き形」「その他」に分類されています。" +
            "下表を参考に、太陽電池アレイを屋根や屋上に設置する方式について選択して下さい。" +
            "<table><tr><th>設置方式</th><th>条件</th></tr>" +
            "<tr><td>架台設置形</td><td>太陽電池モジュールを、屋根と空隙を設けて間接に設置した太陽電池アレイで屋根置き形以外のものの場合</td></tr>" +
            "<tr><td>屋根置き形</td><td>太陽電池モジュールを、屋根と平行に空隙を設けて間接に設置した場合</td></tr>" +
            "<tr><td>その他</td><td>上記以外の設置方式で、屋根用アレイのうち「屋根材一体形」の場合、壁用アレイ及び窓用アレイ等の場合</td></tr></table></li></ul>",
    },
    pv_panel_houi: {
        title: "パネル設置方位（方位角）",
        text: "<ul><li>太陽光発電受光面の法線方向の水平部分が真南に対し、東回りもしくは西回りに振れた角度で示しています。下図を参考に、設置方位角を選択して下さい。<br>" +
            "<img src='/img/app/pv001.jpg'></li></ul>",
    },
    pv_panel_keisha: {
        title: "パネル設置角度（傾斜角）",
        text: "<ul><li>太陽光発電が設置された傾斜角（水平面からの角度）を選択して下さい。90度を超える場合は90度を選択して下さい。</li>" +
            "<li>尺貫法から換算する場合は、下表を参考にしてください。" +
            "<table><tr><th rowspan='2'>尺貫法による角度</th><th colspan='2'>傾斜角</th></tr>" +
            "<tr><th>換算値</th><th>選択肢</th></tr>" +
            "<tr><td>三寸勾配</td><td>約 16.70 度</td><td rowspan='2'>20度</td></tr>" +
            "<tr><td>四寸勾配</td><td>約 21.80 度</td></tr>" +
            "<tr><td>五寸勾配</td><td>約 26.57 度</td><td rowspan='3'>30度</td></tr>" +
            "<tr><td>六寸勾配</td><td>約 30.96 度</td></tr>" +
            "<tr><td>七寸勾配</td><td>約 34.99 度</td></tr></table></li></ul>",
    },
    sw_saiyou: {
        title: "液体集熱式太陽熱利用設備の設置",
        text: "<ul><li>太陽熱を利用して給湯する装置のうち、規定する条件に適合する「太陽熱温水器」や「ソーラーシステム」を設置している場合に、「設置する」を選択することができます。" +
            "ただし、空気集熱式太陽熱利用設備で給湯の一部を賄うものとは併用はできません（空気集熱式太陽熱利用設備を暖房のみに使用する場合はこの限りではありません）。</li>" +
            "<li>太陽熱利用給湯設備を設置する場合は、評価対象住戸が建設される地域の「年間日射地域区分」を確認して、該当する区分を選択して下さい。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "日射地域区分の詳細は、<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>「2.エネルギー消費性能の算定方法」</a>の" +
                "「第十一章第二節日射に関する地域の区分と日射量等」を参照して下さい。",
        },
    },
    sw_sr: {
        title: "設備の種類",
        text: "<ul><li>太陽熱温水器とは、太陽熱を利用して給湯する装置のうち、JIS A4111 に規定される集熱部と貯湯部との間の熱輸送に自然循環作用を利用する自然循環形温水器、" +
            "または集熱部と貯湯部とが一体となったくみ置形温水器で、JIS A4111「太陽熱温水器」に規定される集熱性能に適合している機器を評価対象とします。</li>" +
            "<li>ソーラーシステムとは、太陽熱を利用して給湯する装置のうち、JIS A4112 に規定される集熱媒体を強制循環する太陽集熱器と、JIS A4113 に規定される蓄熱媒体により" +
            "熱エネルギーを顕熱として貯蔵する太陽蓄熱槽を組み合わせた機器の総称です。JIS A4112「太陽熱集熱器」に規定される集熱性能に適合している製品でかつ液体集熱式集熱器のみを評価対象とします。<br>" +
            "<img src='/img/app/hotwater010.jpg'></li></ul>",
    },
    sw_sr1_menseki: {
        title: "面積の入力方法（太陽熱温水器）",
        text: "<ul><li>「集熱部総面積、または集熱貯湯部総面積」とは、自然循環形温水器の場合は JISA4111 に規定される集熱部総面積、くみ置形温水器の場合は同じく JIS A4111 に規定される集熱貯湯部総面積になります。</li>" +
            "<li>「有効集熱面積」とはISO 9488:1999の8.6節（aperture area）に規定される方法により算出した面積になります。</li></ul>",
    },
    sw_sr1_angle: {
        title: "集熱部の設置方位角",
        text: "<ul><li>太陽熱集熱部の法線方向の水平部分が真南に対し、東回りもしくは西回りに振れた角度で示しています。下図を参考に、設置方位角を選択して下さい。" +
            "<img src='/img/app/hotwater011.jpg'></li></ul>",
    },
    sw_sr1_slope: {
        title: "集熱部の設置傾斜角",
        text: "<ul><li>太陽熱集熱部が設置された傾斜角（水平面からの角度）を選択して下さい。90 度を超える場合は 90 度を選択して下さい。</li>" +
            "<li>尺貫法から換算する場合は、下表を参考にしてください。" +
            "<table><tr><th rowspan='2'>尺貫法による角度</th><th colspan='2'>傾斜角</th></tr>" +
            "<tr><th>換算値</th><th>選択肢</th></tr>" +
            "<tr><td>三寸勾配</td><td>約 16.70 度</td><td rowspan='2'>20度</td></tr>" +
            "<tr><td>四寸勾配</td><td>約 21.80 度</td></tr>" +
            "<tr><td>五寸勾配</td><td>約 26.57 度</td><td rowspan='3'>30度</td></tr>" +
            "<tr><td>六寸勾配</td><td>約 30.96 度</td></tr>" +
            "<tr><td>七寸勾配</td><td>約 34.99 度</td></tr></table></li></ul>",
    },
    sw_sr2_menseki: {
        title: "面積の入力方法（ソーラーシステム）",
        text: "<ul><li>「集熱器総面積」とは、JISA4112 に規定される集熱器総面積になります。</li>" +
            "<li>「有効集熱面積」とはISO 9488:1999の8.6節（aperture area）に規定される方法により算出した面積になります。</li></ul>",
    },
    sw_sr2_angle: {
        title: "集熱部の設置方位角",
        text: "<ul><li>太陽熱集熱部の法線方向の水平部分が真南に対し、東回りもしくは西回りに振れた角度で示しています。下図を参考に、設置方位角を選択して下さい。" +
            "<img src='/img/app/hotwater011.jpg'></li></ul>",
    },
    sw_sr2_slope: {
        title: "集熱部の設置傾斜角",
        text: "<ul><li>太陽熱集熱部が設置された傾斜角（水平面からの角度）を選択して下さい。90 度を超える場合は 90 度を選択して下さい。</li>" +
            "<li>尺貫法から換算する場合は、下表を参考にしてください。" +
            "<table><tr><th rowspan='2'>尺貫法による角度</th><th colspan='2'>傾斜角</th></tr>" +
            "<tr><th>換算値</th><th>選択肢</th></tr>" +
            "<tr><td>三寸勾配</td><td>約 16.70 度</td><td rowspan='2'>20度</td></tr>" +
            "<tr><td>四寸勾配</td><td>約 21.80 度</td></tr>" +
            "<tr><td>五寸勾配</td><td>約 26.57 度</td><td rowspan='3'>30度</td></tr>" +
            "<tr><td>六寸勾配</td><td>約 30.96 度</td></tr>" +
            "<tr><td>七寸勾配</td><td>約 34.99 度</td></tr></table></li></ul>",
    },
    sw_sr2_tankyouryo: {
        title: "貯湯タンクの容量",
        text: "<ul><li>貯湯タンクの容量は、 JIS A 4113（太陽蓄熱槽）で規定される貯湯槽容量で確認することを前提とし、小数点第一位を四捨五入し整数値とした値で入力して下さい。ただし、JIS A 4113（太陽蓄熱槽）で" +
            "規定される貯湯槽容量の代わりに、別途定める方法により計測した値を使用することもできます。</li>" +
            "<li>ソーラーシステムの貯湯タンクが複数ある場合はそれぞれの貯湯タンクのタンク容量を合計した値を入力して下さい。</li></ul>",
        reference: {
            title: "参照 住宅・建築物の省エネルギー基準及び低炭素建築物の認定基準に関する技術情報",
            text: "貯湯タンクの容量の確認方法については、「<a href='http://www.kenken.go.jp/becc/house.html' target='_blank'>設計一次エネルギー消費量算定方法</a>」の" +
                "「7-2　太陽熱利用給湯設備　付録A ソーラーシステムのタンク容量」を参照して下さい。",
        },
    },
    om_saiyou: {
        title: "空気集熱式太陽熱利用設備",
        text: "<ul><li>空気集熱式太陽熱利用設備のうち、以下1.～4.の条件を全て満たし、5.の表A.1に示す種類に該当する場合に、「設置する」を選択することができます。" +
            "<ol><li>JIS A 4112またはSS－TS010に適合する空気集熱式集熱器（以下、集熱器と記す）で構成される集熱器群を有する。</li>" +
            "<li>集熱部において太陽熱で温められた外気を、直接、または、蓄熱部とする床下を介して居室に給気する。</li>" +
            "<li>集熱部において太陽熱で温められた外気を床下に給気する場合、床下を構成する部材の劣化対策として、" +
            "防腐・防蟻処理等を施す際には、人体に影響のある薬剤は使用せず、揮発性の低い薬剤等を選定するなどの配慮を行っている。</li>" +
            "<li>床下を経由して外気を導入する換気方式を併用していない。また、空気集熱式太陽熱利用設備で給湯する場合に、液体集熱式太陽熱利用設備と併用して給湯を行っていない。</li>" +
            "<li>集熱部の一部を給湯に利用するか否か、また空気搬送ファンや循環ポンプの動力を太陽光発電装置で賄っているかの組み合わせにより" +
            "表A.1の番号1～8に示す8種類の空気集熱式太陽熱利用設備のいずれかに該当する。<img src='/img/help/om_saiyou.png' />" +
            "<ul><li>「給湯部」とは、集熱量の一部を給湯に利用するための設備</li>" +
            "<li>「自立運転用太陽光発電装置」とは、発電した電力を空気搬送ファンもしくは循環ポンプの動力として使用する ために設ける専用の装置</li></ul></li></ol></li>" +
            "<li>空気集熱式太陽熱利用設備を設置する場合は、評価対象住戸が建設される地域の「年間日射地域区分」を確認して、該当する区分を選択して下さい。（8地域以外）。</li></ul>",
        reference: {
            title: "参照 平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "日射地域区分の詳細は、<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>" +
                "「2.エネルギー消費性能の算定方法」</a>の「第十一章第二節日射に関する地域の区分と日射量等」を参照して下さい。",
        },
    },
    om_panelsuu: {
        title: "集熱器群の数",
        text: "<ul><li>「集熱器群」とは、評価対象に選んだ「集熱部」において同じ傾斜角で設置される、同一仕様の集熱器の集合のことを言います。ここでは、その集熱器群がいくつあるかを選択してください。" +
            "例えば、同じ傾斜角で同一仕様の集熱器群を設置している場合は「1面」を選択してください。異なる2つの傾斜角で同一仕様のものを設置している場合は「2面」を選択することになります。</li></ul>",
    },
    om_panel_houi: {
        title: "集熱部の方位角",
        text: "<ul><li>「集熱部」とは、同じ方位角で設置される集熱器群の集合のことを言います。</li>" +
            "<li>太陽熱集熱部の法線方向の水平部分が真南に対し、東回りもしくは西回りに振れた角度で示しています。下図を参考に、設置方位角を選択して下さい。</li>" +
            "<li>「集熱部」が複数ある場合は、面積が最も大きな集熱部の方位角を選択して下さい。最も面積が大きな集熱部が複数ある場合は、いずれか一つの集熱部を任意に選ぶことができます。<br>" +
            "<img src='/img/app/hotwater011-1.png'><br><img src='/img/app/hotwater011-2.png'></li></ul>",
    },
    om_fan_jirituunten: {
        title: "空気搬送ファンの自立運転用太陽光発電装置",
        text: "<ul><li>「空気搬送ファンの自立運転用太陽光発電装置」とは、発電した電力を空気搬送ファンの動力として使用するための装置で、この装置を採用している場合は、空気搬送ファンが稼働する時刻において、" +
            "その消費電力量はゼロになります。空気搬送ファンのために自立運転用太陽光発電装置を採用している場合は、「採用する」を選択してください。</li></ul>",
    },
    om_fan_type: {
        title: "空気搬送ファンの種別",
        text: "<ul><li>空気を搬送するためのファンがDC（直流）ファンかAC（交流）ファンのどちらであるかを確認して選択してください。</li></ul>",
    },
    om_fan_test: {
        title: "機外静圧をゼロとした時の空気搬送ファンの風量",
        text: "<ul><li>空気搬送ファンのカタログ等に記載されている機外静圧と風量の特性曲線から機外静圧をゼロとしたときの風量を読み取り、入力してください。</li>" +
            "<li>機外静圧と風量の特性曲線等が不明の場合は、空気集熱式太陽熱利用設備を設置された事業者（工務店もしくは製造メーカー）までお問合せください。</li></ul>",
    },
    om_pump_jirituunten: {
        title: "循環ポンプの自立運転用太陽光発電装置",
        text: "<ul><li>「循環ポンプの自立運転用太陽光発電装置」とは、発電した電力を循環ポンプの動力として使用するための装置で、この装置を採用している場合は、循環ポンプが稼働する時刻において、" +
            "その消費電力量はゼロになります。循環ポンプのために自立運転用太陽光発電装置を採用している場合は、「採用する」を選択してください。</li></ul>",
    },
    om_tankyouryo: {
        title: "給湯部のタンク容量",
        text: "<ul><li>給湯部のタンク容量は JIS A 4113「太陽蓄熱槽」で規定される貯湯槽容量の小数点第一位を四捨五入し整数値とした値を入力してください。</li>" +
            "<li>給湯部の貯湯タンクが複数ある場合は、それぞれの貯湯タンクのタンク容量を合計した値を入力することもできます。</li>" +
            "<li>なお、JIS A 4113「太陽蓄熱槽」で規定される貯湯槽容量の代わりに、<a href='/img/help/9-3_B_tank%20youryou.pdf' target='_blank'>こちら</a>に示す方法により" +
            "計測した値を使用することもできます。</li></ul>",
        reference: {
            title: "平成28年省エネルギー基準に準拠したエネルギー消費性能の評価に関する技術情報（住宅）",
            text: "<a href='http://www.kenken.go.jp/becc/house.html#2' target='_blank'>「2.エネルギー消費性能の算定方法」</a>の「第九章 自然エネルギー利用設備 第三節空気集熱式太陽熱利用設備 付録B 給湯部のタンク容量」",
        },
    },
    om_ufv_area_rate: {
        title: "集熱後の空気を供給する床下の面積の比",
        text: "床下空間全体の面積に対する集熱後の空気を供給する床下空間の面積の割合になります。値は、100分の1未満の端数を切り下げた小数第二位までとし、パーセント単位（100倍して整数値）で入力してください。",
    },
    om_ufv_dannetsu: {
        title: "床下空間の断熱",
        text: "断熱区画内とは、断熱材等の連続した熱的境界の内側の部分を言います。",
    },
    om_panel_menseki: {
        title: "集熱器群の面積",
        text: "<ul><li>集熱器群を構成する集熱器の面積の合計を入力してください。面積は小数点第二位を四捨五入し、小数点第一位までの値を入力してください。</li>" +
            "<li>熱器群を構成する集熱器が、JIS A 4112またはSS-TS010が定める集熱性能試験を実施した集熱器で、さらに集熱性能試験時と同じ形状で施工されている場合（縦および横の寸法が変わらない場合）は、" +
            "集熱器の面積をJIS A 4112またはSS-TS010による集熱器総面積としてください。</li>" +
            "<li>上記に該当しない以下のいずれかの場合は、JIS A 4112またはSS-TS010が定める集熱器総面積の算定方法により求めた値を集熱器の面積としてください。" +
            "<ol><li>集熱器群を構成する集熱器が、JIS A 4112またはSS-TS010が定める集熱性能試験を実施した集熱器であり、さらに集熱性能試験時と異なる形状で施工されている場合（切断するなどして縦もしくは横、" +
            "あるいはその両方の寸法が変わる場合）</li>" +
            "<li>集熱器群を構成する集熱器が、JIS A 4112またはSS-TS010が定める集熱性能試験を実施していない集熱器である場合</li></ol></li></ul>",
    },
    om_panel_keisha: {
        title: "集熱器群の傾斜角",
        text: "<ul><li>太陽熱集熱部が設置された傾斜角（水平面からの角度）を選択して下さい。90 度を超える場合は 90 度を選択して下さい。</li>" +
            "<li>尺貫法から換算する場合は、下表を参考にしてください。" +
            "<table><tr><th rowspan='2'>尺貫法による角度</th><th colspan='2'>傾斜角</th></tr>" +
            "<tr><th>換算値</th><th>選択肢</th></tr>" +
            "<tr><td>三寸勾配</td><td>約 16.70 度</td><td rowspan='2'>20度</td></tr>" +
            "<tr><td>四寸勾配</td><td>約 21.80 度</td></tr>" +
            "<tr><td>五寸勾配</td><td>約 26.57 度</td><td rowspan='3'>30度</td></tr>" +
            "<tr><td>六寸勾配</td><td>約 30.96 度</td></tr>" +
            "<tr><td>七寸勾配</td><td>約 34.99 度</td></tr></table></li></ul>",
    },
    om_panel_input: {
        title: "集熱器群の仕様の入力",
        text: "<ul><li>集熱器群の詳細な性能を入力することができます。入力する場合は「入力する」を選択してください。</li></ul>",
    },
    om_panel_d0: {
        title: "集熱器の集熱効率特性線図一次近似式の切片",
        text: "<ul><li>集熱器の集熱効率特性線図一次近似式の切片は、JIS A4112「太陽集熱器」、または、SS-TS010「空気集熱器の集熱効率試験方法」で規定された" +
            "集熱効率特性試験による空気集熱式集熱器の集熱効率特性線図一次近似の定数を入力してください。</li>" +
            "<li>集熱器の集熱効率特性線図一次近似式の切片が不明の場合は、空気集熱式太陽熱利用設備を設置された事業者（工務店もしくは製造メーカー）までお問合せください。</li></ul>",
    },
    om_panel_d1: {
        title: "集熱器の集熱効率特性線図一次近似式の傾き",
        text: "<ul><li>集熱器の集熱効率特性線図一次近似式の傾きは、JIS A4112「太陽集熱器」、または、SS-TS010「空気集熱器の集熱効率試験方法」で規定された" +
            "集熱効率特性試験による空気集熱式集熱器の集熱効率特性線図一次近似の一次係数の絶対値を入力してください。</li>" +
            "<li>集熱器の集熱効率特性線図一次近似式の傾きが不明の場合は、空気集熱式太陽熱利用設備を設置された事業者（工務店もしくは製造メーカー）までお問合せください。</li></ul>",
    },
    om_panel_mfan: {
        title: "集熱器の集熱性能試験時における単位面積当たりの空気の質量流量",
        text: "<ul><li>集熱器の集熱性能試験時における単位面積当たりの空気の質量流量は、JIS A4112「太陽集熱器」、または、SS-TS010「空気集熱器の集熱効率試験方法」で規定された" +
            "集熱効率特性試験実施時の集熱媒体質量流量を入力してください。</li>" +
            "<li>集熱器の集熱性能試験時における単位面積当たりの空気の質量流量が不明の場合は、空気集熱式太陽熱利用設備を設置された事業者（工務店もしくは製造メーカー）までお問合せください。</li></ul>",
    },
    search_cogen_text: {
        title: "コージェネレーション機器",
        text: "<ul><li>該当するコージェネレーション機器を検索することができます。</li>" +
            "<li>コージェネレーション機器を販売する「ブランド事業者名」や、機器の「発電ユニット番号」、「貯湯ユニット品番」、あるいは「成績証明書番号または自己適合宣言書番号品番」の" +
            "一部の文字やアルファベット記号、数字を入力すると対象となる機器が絞り込まれます。</li>" +
            "<li>入力する文字は半角英数字です。</li></ul>",
    },
}